/* Bahasa Melayu — Malay */
const ms = {
  nav: {
    home: 'Laman Utama',
    imageConverter: 'Penukar Imej',
    imageCompressor: 'Pemampat Imej',
    otherTools: 'Alat Lain',
    resizeImage: 'Ubah Saiz Imej',
    cropImage: 'Potong Imej',
    photoEditor: 'Editor Foto',
    removeBackground: 'Buang Latar Belakang',
    watermarkImage: 'Tera Air Imej',
    qrCodeGenerator: 'Penjana Kod QR',
    qrCodeScanner: 'Pengimbas Kod QR',
    aboutUs: 'Tentang Kami',
    faceBlur: 'Kabur Wajah',
  },

  hero: {
    heading: 'Semua Alat Imej Yang Anda Perlukan',
    subheading: 'Alat dalam talian percuma untuk menukar, memampatkan, mengubah saiz, memotong, mengedit dan mengubah imej. Semua pemprosesan berlaku dalam pelayar anda — pantas dan selamat.',
  },

  tools: {
    compressImage: { title: 'Mampatkan Imej', desc: 'Mampatkan JPG, PNG, SVG dan GIF sambil mengekalkan kualiti.' },
    resizeImage: { title: 'Ubah Saiz Imej', desc: 'Ubah saiz mengikut peratusan atau piksel.' },
    cropImage: { title: 'Potong Imej', desc: 'Potong JPG, PNG dan GIF dengan mudah.' },
    convertToJpg: { title: 'Tukar ke JPG', desc: 'Tukar PNG, GIF, TIF, SVG, WEBP dan lain-lain ke JPG secara pukal.' },
    convertFromJpg: { title: 'Tukar dari JPG', desc: 'Tukar imej JPG ke PNG dan GIF.' },
    qrCodeGenerator: { title: 'Penjana Kod QR', desc: 'Jana kod QR tersuai untuk URL, teks, WiFi, kenalan dan lain-lain.' },
    qrCodeScanner: { title: 'Pengimbas Kod QR', desc: 'Imbas kod QR seketika menggunakan kamera atau muat naik imej.' },
    blurFace: { title: 'Kabur Wajah', desc: 'Kesan dan kaburkan wajah dalam imej secara automatik untuk privasi.' },
    removeBackground: { title: 'Buang Latar Belakang', desc: 'Buang latar belakang imej dengan ketepatan tinggi.' },
    watermarkImage: { title: 'Tera Air Imej', desc: 'Tambah tera air pada imej dalam beberapa saat.' },
  },

  whyChoose: {
    label: 'Mengapa Pilih Kami',
    heading: 'Cara Lebih Bijak untuk Mengedit Imej',
    subheading: 'Dipercayai oleh ribuan pencipta, pereka dan pembangun di seluruh dunia.',
    reasons: {
      fast: { title: 'Pantas Seperti Kilat', desc: 'Semua pemprosesan berlaku terus dalam pelayar anda. Tiada muat naik ke pelayan luaran.' },
      private: { title: '100% Selamat dan Peribadi', desc: 'Fail anda tidak pernah meninggalkan peranti anda. Kami tidak menyimpan atau berkongsi imej anda.' },
      noLimits: { title: 'Tiada Had, Tiada Daftar', desc: 'Gunakan semua alat sesuka hati — percuma sepenuhnya.' },
      quality: { title: 'Kualiti Profesional', desc: 'Algoritma kami memberikan hasil peringkat profesional.' },
      batch: { title: 'Pemprosesan Pukal', desc: 'Proses beberapa fail sekaligus.' },
      everywhere: { title: 'Berfungsi Di Mana Sahaja', desc: 'Berfungsi dengan sempurna pada desktop, tablet dan telefon.' },
    },
    stats: {
      imagesProcessed: 'Imej Diproses',
      countriesServed: 'Negara Dilayan',
      uptime: 'Masa Operasi',
      freeTools: 'Alat Percuma',
    },
  },

  footer: {
    tagline: 'Alat imej dalam talian percuma — tukar, mampatkan, ubah saiz, potong dan edit imej dalam beberapa saat.',
    imageTools: 'Alat Imej',
    moreTools: 'Lebih Banyak Alat',
    company: 'Syarikat',
    contact: 'Hubungi',
    allRightsReserved: 'Semua hak terpelihara.',
    privacyPolicy: 'Dasar Privasi',
    termsOfService: 'Terma Perkhidmatan',
  },

  faq: {
    badge: 'Soalan Lazim',
    heading: 'Soalan Lazim',
    subheading: 'Jawapan pantas untuk soalan biasa tentang alat ini.',
    stillHaveQuestions: 'Masih ada soalan? Kami sedia membantu!',
    reachOut: 'Hubungi Pasukan Kami',
    questionHeader: 'Soalan',
  },

  contactForm: {
    badge: 'Hubungi Kami',
    title: 'Hubungi Kami',
    subtitle: 'Kami ingin mendengar daripada anda. Hantar mesej kepada kami!',
    nameLabel: 'Nama',
    namePlaceholder: 'Nama penuh anda',
    emailLabel: 'E-mel',
    emailPlaceholder: 'anda@email.com',
    subjectLabel: 'Subjek',
    subjectPlaceholder: 'Ini tentang apa?',
    messageLabel: 'Mesej',
    messagePlaceholder: 'Tulis mesej anda di sini…',
    errName: 'Nama diperlukan',
    errEmail: 'E-mel diperlukan',
    errEmailInvalid: 'Masukkan e-mel yang sah',
    errSubject: 'Subjek diperlukan',
    errMessage: 'Mesej diperlukan',
    sending: 'Menghantar…',
    send: 'Hantar Mesej',
    successTitle: 'Mesej Dihantar!',
    successMsg: 'Terima kasih kerana menghubungi kami. Kami akan membalas tidak lama lagi.',
    sendAnother: 'Hantar Lagi',
    sendError: 'Sesuatu telah berlaku. Sila cuba lagi.',
  },

  about: {
    label: 'Tentang',
    heading: 'Dibina untuk Pencipta, oleh Pencipta',
    subheading: 'Kami percaya alat imej yang berkuasa seharusnya percuma, pantas dan boleh diakses oleh semua orang.',
    missionTitle: 'Misi Kami',
    missionText: 'photremium.com dibina dengan matlamat mudah: menyediakan pengalaman pengeditan imej yang paling intuitif, pantas dan peribadi di web.',
    privacyTitle: 'Privasi Dahulu',
    privacyText: 'Kami tidak memuat naik, menyimpan atau memproses imej anda dari jauh. Semua kekal pada peranti anda.',
    techTitle: 'Teknologi Moden',
    techText: 'Dibina menggunakan teknologi web terkini termasuk WebAssembly, Canvas API dan React moden.',
    communityTitle: 'Dipacu Komuniti',
    communityText: 'Setiap ciri diilhamkan oleh maklum balas pengguna sebenar.',
    globalTitle: 'Capaian Global',
    globalText: 'Digunakan oleh pencipta dari lebih 120 negara.',
  },

  seo: {
    homeTitle: 'photremium.com — Penukar, Pemampat dan Editor Imej Dalam Talian Percuma',
    homeDesc: 'Tukar, mampatkan, ubah saiz, potong dan edit imej secara percuma dalam talian.',
    homeKeywords: 'penukar imej, pemampat imej, ubah saiz imej, potong imej, editor foto',
    aboutTitle: 'Tentang photremium.com — Misi Kami',
    aboutDesc: 'Ketahui tentang photremium.com, kit alat imej dalam talian percuma yang dipercayai oleh jutaan orang.',
    aboutKeywords: 'tentang photremium.com, alat imej, editor imej percuma',
  },

    privacyPolicyPage: {
    seo: {
      title: 'Dasar Privasi — Photremium | Tiada Muat Naik Pelayan, Sifar Penyimpanan Data',
      description: 'Dasar Privasi Photremium menerangkan cara kami melindungi privasi anda. Semua pemprosesan imej berlaku 100% dalam penyemak imbas anda — tiada muat naik fail ke mana-mana pelayan, tiada data peribadi dikumpul, tiada penjejakan.',
      ogTitle: 'Dasar Privasi — Photremium | Tiada Muat Naik, Sifar Storan',
      ogDescription: 'Fail anda kekal pada peranti anda. Photremium memproses semua imej secara setempat dalam penyemak imbas anda tanpa hubungan pelayan, tiada data disimpan dan tiada penjejakan.',
      twitterTitle: 'Dasar Privasi — Photremium',
      twitterDescription: '100% alatan imej berasaskan pelayar. Tiada muat naik, tiada storan, tiada penjejakan. Baca dasar privasi penuh kami.',
      schemaName: 'Dasar Privasi - Photremium',
      schemaDescription: 'Dasar Privasi Photremium - tiada muat naik pelayan, tiada data disimpan, 100% pemprosesan imej dalam penyemak imbas.'
    },
    hero: {
      badge: 'Dasar Privasi',
      titlePrefix: 'Privasi Anda Adalah Kami',
      titleHighlight: 'Keutamaan Teratas',
      subPrefix: 'photremium.com dibina berdasarkan prinsip mudah —',
      subStrong: 'fail anda tidak pernah meninggalkan peranti anda',
      subSuffix: 'Setiap alat imej di tapak ini berjalan sepenuhnya di dalam penyemak imbas anda. Tiada muat naik. Tiada awan. Tiada kompromi.',
      effectiveLabel: 'Berkesan',
      lastUpdatedLabel: 'Kemas kini terakhir',
      worldwideLabel: 'Berlaku di seluruh dunia'
    },
    trustCards: [
      {
        title: 'Tiada Muat Naik Pelayan',
        desc: 'Fail anda tidak pernah meninggalkan peranti anda. Semua pemprosesan adalah 100% dalam penyemak imbas.'
      },
      {
        title: 'Sifar Penyimpanan Data',
        desc: 'Kami tidak menyimpan apa-apa tentang anda, imej anda atau aktiviti anda.'
      },
      {
        title: 'Tiada Penjejakan',
        desc: 'Tiada penjejakan tingkah laku, tiada cap jari, tiada profil.'
      },
      {
        title: 'Mesra GDPR',
        desc: 'Direka dari bawah ke atas untuk menghormati peraturan privasi global.'
      }
    ],
    contentsTitle: 'Kandungan',
    toc: {
      overview: 'Gambaran keseluruhan',
      'no-upload': 'Tiada Pemprosesan Pelayan',
      'data-collect': 'Data yang Kami Kumpul',
      cookies: 'Kuki & Storan',
      'third-party': 'Perkhidmatan Pihak Ketiga',
      analytics: 'Analitis',
      children: 'Privasi Kanak-kanak',
      rights: 'Hak Anda',
      security: 'Keselamatan',
      changes: 'Perubahan Dasar',
      contact: 'Hubungi Kami'
    },
    sections: {
      overview: {
        title: '1. Gambaran keseluruhan',
        subtitle: 'Perkara yang dilindungi oleh dasar ini',
        p1Prefix: 'Dasar Privasi ini menerangkan bagaimana',
        p1Middle: '("kami", "kami", atau "kami") mengendalikan - atau lebih tepat,',
        p1Italic: 'tidak mengendalikan',
        p1Suffix: 'maklumat peribadi anda apabila anda menggunakan alat imej dalam talian percuma kami di',
        p2: 'Tidak seperti aplikasi web tradisional yang menghantar fail ke pelayan jauh untuk diproses, photremium.com menggunakan API pelayar moden (Canvas API, WebAssembly, WebWorkers) untuk melaksanakan setiap operasi secara setempat pada peranti anda. Hasilnya: tiada penghantaran data, tiada storan, tiada risiko.',
        calloutLabel: 'Ringkasan bahasa Inggeris biasa:',
        calloutText: 'Kami tidak dapat melihat imej anda, kami tidak mahu, dan teknologi kami direka bentuk secara khusus supaya kami tidak dapat melihatnya.'
      },
      noUpload: {
        title: '2. Tiada Pemprosesan Pelayan — Pernah',
        subtitle: 'Bagaimana alat kami sebenarnya berfungsi',
        introPrefix: 'Setiap alat di photremium.com — penukar imej, pemampat, penubah saiz semula, pengalih keluar latar belakang, kabur muka, tera air, pangkas dan alatan kod QR — memproses fail anda',
        introStrong: '100% di dalam pelayar web anda',
        introSuffix: 'menggunakan JavaScript dan WebAssembly pihak pelanggan.',
        points: [
          {
            label: 'Tiada muat naik fail pernah berlaku.',
            text: 'Apabila anda memilih fail, ia dibaca oleh API Fail penyemak imbas anda dan diproses dalam memori — ia tidak pernah dihantar melalui rangkaian.'
          },
          {
            label: 'Tiada pelayan menerima imej anda.',
            text: 'CDN kami hanya menyediakan aset HTML, CSS dan JavaScript yang diperlukan untuk menjalankan apl — bukan fail anda.'
          },
          {
            label: 'Tiada simpanan sementara.',
            text: 'Hasil yang diproses hanya wujud dalam memori penyemak imbas anda dan dikeluarkan apabila anda menutup atau menavigasi keluar dari halaman.'
          },
          {
            label: 'Berfungsi di luar talian.',
            text: 'Kebanyakan alatan terus berfungsi tanpa sambungan internet selepas pemuatan halaman awal — bukti selanjutnya tiada pelayan terlibat.'
          }
        ],
        callout: 'Anda boleh mengesahkannya sendiri: buka tab Rangkaian penyemak imbas anda dalam Alat Pembangun, pilih imej dan sahkan bahawa tiada data fail dihantar ke mana-mana pelayan luaran.'
      },
      dataCollect: {
        title: '3. Data yang Kami Kumpul (dan Jangan Kumpul)',
        subtitle: 'Ketelusan penuh pada amalan data',
        headers: {
          type: 'Jenis Data',
          collected: 'Dikumpul?',
          whereWhy: 'Di mana / Mengapa'
        },
        rows: [
          {
            type: 'Imej / fail anda',
            badge: 'tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'Diproses sepenuhnya dalam penyemak imbas anda — tidak pernah dihantar'
          },
          {
            type: 'Nama / alamat e-mel',
            badge: 'tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'Tiada akaun atau pendaftaran diperlukan untuk menggunakan sebarang alat'
          },
          {
            type: 'alamat IP',
            badge: 'minima',
            variant: 'kelabu',
            showX: false,
            whereWhy: 'Log pelayan web standard dikekalkan <= 30 hari, tidak terikat dengan identiti'
          },
          {
            type: 'Jenis penyemak imbas / OS',
            badge: 'minima',
            variant: 'kelabu',
            showX: false,
            whereWhy: 'Dihantar oleh penyemak imbas anda secara automatik; digunakan hanya untuk keserasian'
          },
          {
            type: 'Halaman yang dilawati / klik',
            badge: 'Agregat',
            variant: 'biru',
            showX: false,
            whereWhy: 'Analitik tanpa nama sahaja (tiada pengenalan peribadi)'
          },
          {
            type: 'Keutamaan bahasa',
            badge: 'Tempatan sahaja',
            variant: 'biru',
            showX: false,
            whereWhy: 'Disimpan ke localStorage pada peranti anda — tidak pernah dihantar kepada kami'
          },
          {
            type: 'Data pembayaran / kewangan',
            badge: 'tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'photremium.com adalah percuma sepenuhnya tanpa bayaran diperlukan'
          }
        ]
      },
      cookies: {
        title: '4. Kuki & Storan Tempatan',
        subtitle: 'Perkara yang disimpan pada peranti anda',
        intro: 'photremium.com tidak menggunakan kuki pengiklanan, tiada kuki penjejakan merentas tapak dan tiada kuki pihak ketiga. Satu-satunya storan penyemak imbas yang kami gunakan adalah untuk fungsi tapak penting.',
        points: [
          {
            label: 'Keutamaan bahasa',
            text: 'Disimpan dalam localStorage supaya tapak mengingati bahasa pilihan anda antara lawatan. Tidak pernah dihantar ke pelayan kami.'
          },
          {
            label: 'Pilihan tema / UI',
            text: 'Jika anda menetapkan pilihan paparan, ia disimpan secara setempat pada peranti anda sahaja.'
          },
          {
            label: 'Tiada kuki sesi.',
            text: 'photremium.com tidak mempunyai sistem log masuk, jadi tiada kuki ID sesi pernah ditulis.'
          }
        ],
        callout: 'Anda boleh mengosongkan semua storan tempatan photremium.com pada bila-bila masa melalui tetapan penyemak imbas anda (Tetapan -> Privasi -> Kosongkan data penyemakan imbas -> Data & kuki cache). Melakukannya tidak mempunyai kesan ke atas keupayaan anda untuk menggunakan alatan.'
      },
      thirdParty: {
        title: '5. Perkhidmatan Pihak Ketiga',
        subtitle: 'Perkhidmatan luar yang kami gunakan dan sebabnya',
        intro: 'photremium.com menggunakan set minimum perkhidmatan pihak ketiga yang dipercayai semata-mata untuk infrastruktur dan prestasi. Tiada satu pun daripada perkhidmatan ini menerima imej anda atau sebarang maklumat yang boleh dikenal pasti secara peribadi.',
        headers: {
          service: 'Perkhidmatan',
          purpose: 'Tujuan',
          dataShared: 'Data Dikongsi',
          privacyPolicy: 'Dasar Privasi'
        },
        rows: [
          {
            service: 'Halaman Cloudflare',
            purpose: 'Pengehosan & penghantaran CDN aset tapak',
            dataShared: 'Alamat IP, pengepala HTTP (standard)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Font Hebat',
            purpose: 'Fon ikon dimuatkan daripada CDN',
            dataShared: 'Alamat IP (permintaan CSS sahaja)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Fon Google',
            purpose: 'Pemuatan muka taip (jika berkenaan)',
            dataShared: 'Alamat IP (permintaan fon sahaja)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Kami tidak berkongsi data anda dengan pengiklan, broker data atau mana-mana pihak ketiga lain selain daripada penyedia infrastruktur yang disenaraikan di atas.'
      },
      analytics: {
        title: '6. Analitis',
        subtitle: 'Agregat, data penggunaan yang menghormati privasi',
        introPrefix: 'Untuk memahami alat yang popular dan cara menambah baik tapak, kami mungkin mengumpul',
        introStrong: 'diagregatkan, tanpa nama',
        introSuffix: 'statistik penggunaan seperti:',
        points: [
          'Bilangan paparan halaman setiap alat (tiada pengenalan pengguna)',
          'Sumber rujukan (cth. Carian Google, pautan terus) — tiada data peribadi',
          'Data geografi peringkat negara (bukan bandar atau lokasi tepat)',
          'Jenis penyemak imbas / peranti untuk analisis keserasian'
        ],
        calloutLabel: 'Tiada data dipautkan kepada anda secara peribadi.',
        calloutText: 'Kami tidak menggunakan Google Analitis atau Meta Pixel. Sebarang analitis yang kami gunakan ialah alatan yang mengutamakan privasi (mis. Boleh dipercayai atau serupa).'
      },
      children: {
        title: '7. Privasi Kanak-kanak',
        subtitle: 'COPPA & pematuhan keselamatan kanak-kanak',
        p1: 'photremium.com tidak mengumpul sebarang maklumat peribadi daripada kanak-kanak di bawah umur 13 tahun (atau 16 tahun di Kesatuan Eropah di bawah GDPR) dengan sengaja. Memandangkan kami tidak mengumpul data peribadi daripada mana-mana pengguna, tiada apa yang istimewa untuk dilakukan untuk pengguna yang lebih muda — tapak ini sama selamat untuk semua orang.',
        p2Prefix: 'Jika anda percaya seorang kanak-kanak telah menyerahkan maklumat peribadi melalui borang hubungan kami, sila hubungi kami dengan segera di',
        p2Suffix: 'dan kami akan segera memadamkannya.'
      },
      rights: {
        title: '8. Hak Anda',
        subtitle: 'GDPR, CCPA, and global privacy rights',
        intro: 'Oleh kerana photremium.com tidak mengumpul maklumat yang boleh dikenal pasti secara peribadi, kebanyakan hak subjek data digunakan secara remeh — tiada data tentang anda untuk diakses, diperbetulkan atau dipadamkan. Namun begitu, kami mengiktiraf sepenuhnya dan menghormati hak berikut:',
        points: [
          {
            label: 'Hak untuk mengakses',
            text: 'Anda boleh meminta salinan mana-mana data yang kami simpan tentang anda. (Tiada satu pun selain log tanpa nama.)'
          },
          {
            label: 'Hak untuk pembetulan',
            text: 'Anda boleh meminta pembetulan data peribadi yang tidak tepat.'
          },
          {
            label: 'Hak untuk memadam ("Hak untuk dilupakan")',
            text: 'Anda boleh meminta pemadaman mana-mana data peribadi yang kami pegang (GDPR Art. 17, CCPA).'
          },
          {
            label: 'Hak untuk membantah / menarik diri',
            text: 'Anda boleh menarik diri daripada mana-mana koleksi analitis masa hadapan dengan menggunakan alat pilih keluar atau blok iklan peringkat penyemak imbas.'
          },
          {
            label: 'Hak untuk mudah alih data',
            text: 'Semua kerja anda dimuat turun terus ke peranti anda — tiada permintaan eksport diperlukan.'
          }
        ],
        callout: 'Hak ini dikenakan kepada semua pengguna di seluruh dunia tanpa mengira bidang kuasa — kami menggunakan standard tertinggi (GDPR) sebagai garis dasar kami.'
      },
      security: {
        title: '9. Keselamatan',
        subtitle: 'Bagaimana kami melindungi pengalaman anda',
        intro: 'Data yang paling selamat adalah data yang tidak pernah dikumpulkan. photremium.com seni bina sisi klien bermakna pelanggaran pelayan tidak boleh mendedahkan fail anda kerana fail anda tidak pernah berada di pelayan kami. Langkah keselamatan tambahan termasuk:',
        points: [
          {
            label: 'Penguatkuasaan HTTPS',
            text: 'Semua trafik antara penyemak imbas anda dan CDN kami disulitkan melalui TLS 1.2+ dengan HSTS.'
          },
          {
            label: 'Dasar Keselamatan Kandungan (CSP)',
            text: 'Pengepala yang ketat menghalang skrip merentas tapak dan suntikan skrip sebaris.'
          },
          {
            label: 'Audit pergantungan yang kerap',
            text: 'Kami mengaudit dan mengemas kini pakej npm dengan kerap untuk menambal kelemahan yang diketahui.'
          }
        ],
        disclosurePrefix: 'Pendedahan yang bertanggungjawab',
        disclosureTextPrefix: 'Menjumpai isu keselamatan? E-mel kami di',
        disclosureTextSuffix: 'dan kami akan membalas dalam masa 48 jam.'
      },
      changes: {
        title: '10. Perubahan kepada Polisi Ini',
        subtitle: 'Cara kami mengendalikan kemas kini dasar',
        intro: 'Kami mungkin mengemas kini Dasar Privasi ini dari semasa ke semasa untuk mencerminkan perubahan dalam amalan, alatan atau keperluan undang-undang kami. Apabila kita lakukan:',
        points: [
          {
            label: '"Terakhir Dikemas Kini"',
            text: 'tarikh di bahagian atas halaman ini akan disemak.'
          },
          {
            label: 'Perubahan material',
            text: 'akan dimaklumkan melalui notis yang menonjol di halaman utama selama sekurang-kurangnya 30 hari.'
          },
          {
            label: 'Versi sebelumnya',
            text: 'dasar ini akan diarkibkan dan tersedia atas permintaan.'
          }
        ],
        outro: 'Penggunaan photremium.com yang berterusan selepas perubahan diterbitkan merupakan penerimaan dasar yang dikemas kini. Kami menggalakkan anda menyemak halaman ini secara berkala.'
      },
      contact: {
        title: '11. Permintaan Hubungan & Data',
        subtitle: 'Hubungi tentang privasi',
        p1Prefix: 'Untuk sebarang pertanyaan, kebimbangan atau permintaan data rasmi yang berkaitan dengan Dasar Privasi ini, sila hubungi kami. Kami berhasrat untuk menjawab semua pertanyaan berkaitan privasi dalam',
        p1Strong: '5 hari bekerja'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Soalan Privasi?',
      privacyQuestionsDesc: 'Hantarkan kepada kami soalan privasi, permintaan data atau kebimbangan anda dan kami akan membalas dengan segera.',
      versionHistoryTitle: 'Sejarah Versi',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Baharu!',
    download: 'Muat Turun',
    downloadAll: 'Muat Turun Semua',
    downloadAs: 'Muat turun sebagai:',
    zip: 'ZIP',
    separate: 'Berasingan',
    upload: 'Muat Naik',
    dragDrop: 'Seret & lepas imej di sini atau klik untuk semak imbas',
    remove: 'Buang',
    reset: 'Set Semula',
    apply: 'Guna',
    cancel: 'Batal',
    clear: 'Kosongkan',
    close: 'Tutup',
    save: 'Simpan',
    processing: 'Memproses...',
    noFiles: 'Tiada fail dipilih',
    selectFiles: 'Pilih Fail',
    or: 'atau',
    browseFiles: 'Semak Imbas Fail',
    dropHere: 'Lepas imej di sini',
    chooseFiles: 'Pilih Fail',
    pasteHint: 'Anda juga boleh menampal imej',
    quality: 'Kualiti',
    width: 'Lebar',
    height: 'Tinggi',
    format: 'Format',
    compression: 'Pemampatan',
    preview: 'Pratonton',
    original: 'Asal',
    result: 'Keputusan',
    before: 'Sebelum',
    after: 'Selepas',
    startOver: 'Mulakan Semula',
    startOverConfirm: 'Buang semua imej dan mulakan semula?',
    addMoreImages: 'Tambah Lebih Banyak Imej',
    addImage: 'Tambah Imej',
    images: 'imej',
    totalSize: 'Saiz Jumlah',
    size: 'Saiz',
    type: 'Jenis',
    unsavedEdits: 'Anda mempunyai suntingan yang belum disimpan. Tinggalkan halaman ini?',
    compareSlider: 'Gelongsor Perbandingan',
    toggleToolsPanel: 'Toggle Panel Alat',
    closePanel: 'Tutup Panel',
    zoomIn: 'Zum Masuk',
    zoomOut: 'Zum Keluar',
    fit: 'Muat',
    none: 'Tiada',
  },

  compressor: {
    seo: {
      uploadTitle: 'Pemampat Imej — Mampatkan JPG, PNG, SVG, GIF Percuma | photremium.com',
      uploadDesc: 'Mampatkan imej JPG, PNG, SVG dan GIF secara percuma dalam talian. Kurangkan saiz fail sehingga 80% sambil mengekalkan kualiti.',
      uploadKeywords: 'pemampat imej, mampatkan jpg, mampatkan png, kurangkan saiz imej',
      workspaceTitle: 'Memampatkan Imej — Pemampat Imej photremium.com',
      workspaceDesc: 'Laraskan tahap pemampatan dan muat turun imej yang dioptimumkan.',
      workspaceKeywords: 'pemampatan imej, pengoptimuman imej',
    },
    title: 'Pemampat Imej',
    desc: 'Mampatkan imej JPG, PNG dan GIF sehingga 80%. Pantas dan selamat.',
    toCompress: 'untuk dimampatkan',
    compressionForAll: 'Pemampatan untuk semua imej',
    summary: 'Ringkasan',
    originalSize: 'Saiz Asal',
    compressed: 'Dimampatkan',
    saved: 'Jimat',
    compressionLabel: 'Pemampatan:',
    compressing: 'Memampatkan…',
    compressDownload: 'Mampatkan & Muat Turun',
    lowQualityWarning: 'Pemampatan tinggi boleh mengurangkan kejelasan imej dengan ketara.',
    blog: {
      tocTitle: 'Kandungan',
      title: 'Blog Pemampat Imej',
      formatsIntro: 'Alat kami menyokong semua format imej, jadi anda boleh memampatkan mana-mana imej dengan lancar. Senarai penuh format diberikan di bawah:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Apakah pemampat imej?',
          paragraphs: [
            'Pemampat imej ialah perisian atau perkhidmatan dalam talian yang mengurangkan saiz fail imej sambil mengekalkan kualiti visual. Namun, pemampatan berlebihan boleh menjejaskan kualiti dengan ketara.',
          ],
          listTitle: 'JENIS:',
          bullets: [
            'Pemampatan lossy: saiz imej dikurangkan dengan membuang sebahagian data imej. Kualiti mungkin menurun tetapi selalunya sukar disedari oleh mata manusia.',
            'Pemampatan lossless: mengurangkan saiz fail tanpa menjejaskan kualiti visual imej.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Mengapa pilih alat kami?',
          bullets: [
            'Alat pemampat imej berasaskan AI kami berfungsi lancar pada semua peranti untuk hasil terbaik.',
            'Anda boleh memampatkan banyak imej serentak (malah 100+) dengan satu klik sahaja.',
            'Tidak perlu memuat naik imej ke pelayan kami. Semua pemprosesan berlaku secara setempat dalam pelayar anda.',
            'Alat pemampat imej kami percuma sepenuhnya selama-lamanya, dan boleh dikongsi dengan rakan-rakan anda.',
            'Anda boleh memilih peratus pemampatan mengikut keperluan.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: '1. Pilih imej yang anda mahu mampatkan.',
              bullets: [
                'Seret dan lepaskan imej ke kotak muat naik.',
                'Anda juga boleh salin imej dan tampal dalam kotak menggunakan (Ctrl + V).',
                'Penjelajah fail juga disokong melalui butang pilih.',
              ],
            },
            {
              heading: '2. Kemudian pilih peratus pemampatan.',
              bullets: [
                'Peluncur mendatar memberi pengalaman mudah untuk memilih tahap pemampatan. Ikuti julat di bawah untuk hasil yang tepat.',
              ],
              table: {
                headers: ['Peratus Pemampatan', 'Hasil'],
                rows: [
                  ['1%  hingga  40%', 'Kualiti terbaik'],
                  ['41%  hingga  60%', 'Kualiti normal (Disyorkan)'],
                  ['61%  hingga  100%', 'Kualiti rendah'],
                ],
              },
            },
            {
              heading: '3. Semak ruang yang anda jimat.',
              paragraphs: [
                'Semua metrik saiz dipaparkan secara masa nyata. Anda boleh melihat jumlah ruang yang dijimatkan dan melaras tahap pemampatan mengikut keperluan fail anda.',
              ],
            },
            {
              heading: '4. Pilih pilihan muat turun daripada butang togol.',
              bullets: [
                'ZIP: Jika anda memampatkan banyak imej, pilihan ini akan dipaparkan. Ia akan mengarkibkan semua imej termampat ke dalam satu fail ZIP (disyorkan untuk jumlah imej yang besar).',
                'Berasingan: Pilihan ini memuat turun setiap imej secara berasingan, bukan dalam satu ZIP (disyorkan untuk jumlah kecil, kurang daripada 10).',
              ],
            },
            {
              heading: '5. Mampatkan dan muat turun imej.',
              paragraphs: [
                'Butang ini akan memuat turun semua imej termampat secara automatik berdasarkan pilihan muat turun anda.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Kelebihan pemampat imej.',
          bullets: [
            'Mengurangkan kos storan: pemampatan mengurangkan saiz fail imej dengan ketara.',
            'Muat lebih pantas: imej termampat dimuatkan lebih cepat dan meningkatkan pengalaman pengguna.',
            'Penyelesaian had Gmail: had lampiran Gmail 25MB menjadikan pemampatan penting untuk menghantar lebih banyak fail.',
            'Perkongsian dan pemindahan lebih cepat: fail besar mengambil masa lebih lama untuk dihantar; pemampatan menjimatkan masa dan data.',
            'Pengoptimuman pembentangan: imej tidak termampat boleh menyebabkan fail pembentangan terlalu besar, manakala imej termampat menjadikannya jauh lebih ringan.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Format yang disokong.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Penukar Imej — Tukar PNG, JPG, WEBP, GIF, SVG Percuma | photremium.com',
      uploadDesc: 'Tukar imej antara JPG, PNG, WEBP, GIF, SVG, TIFF dan BMP. Penukar format imej dalam talian percuma.',
      uploadKeywords: 'penukar imej, png ke jpg, jpg ke png, penukar webp',
      workspaceKeywords: 'penukaran imej, penukar format imej',

      routeKeywords: {

        'png-to-jpg': 'png untuk ditukar jpg, png to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-png': 'jpg untuk ditukar png, jpg to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'png-to-webp': 'png untuk ditukar webp, png to webp, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-webp': 'jpg untuk ditukar webp, jpg to webp, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'webp-to-jpg': 'webp untuk ditukar jpg, webp to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'webp-to-png': 'webp untuk ditukar png, webp to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'gif-to-jpg': 'gif untuk ditukar jpg, gif to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'gif-to-png': 'gif untuk ditukar png, gif to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'bmp-to-jpg': 'bmp untuk ditukar jpg, bmp to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'bmp-to-png': 'bmp untuk ditukar png, bmp to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'svg-to-png': 'svg untuk ditukar png, svg to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'svg-to-jpg': 'svg untuk ditukar jpg, svg to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'tiff-to-jpg': 'tiff untuk ditukar jpg, tiff to jpg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'tiff-to-png': 'tiff untuk ditukar png, tiff to png, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-gif': 'jpg untuk ditukar gif, jpg to gif, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'png-to-gif': 'png untuk ditukar gif, png to gif, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-bmp': 'jpg untuk ditukar bmp, jpg to bmp, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'png-to-bmp': 'png untuk ditukar bmp, png to bmp, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'webp-to-gif': 'webp untuk ditukar gif, webp to gif, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-ico': 'jpg untuk ditukar ico, jpg to ico, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'png-to-ico': 'png untuk ditukar ico, png to ico, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'jpg-to-svg': 'jpg untuk ditukar svg, jpg to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'png-to-svg': 'png untuk ditukar svg, png to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'webp-to-svg': 'webp untuk ditukar svg, webp to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'gif-to-svg': 'gif untuk ditukar svg, gif to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'bmp-to-svg': 'bmp untuk ditukar svg, bmp to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

        'tiff-to-svg': 'tiff untuk ditukar svg, tiff to svg, penukar imej, png ke jpg, jpg ke png, penukar webp',

      },
    },
    title: 'Penukar Imej',
    desc: 'Tukar imej antara JPG, PNG, WEBP, GIF, SVG, TIFF dan BMP. Tukar berbilang fail secara pukal.',
    toConvert: 'untuk ditukar',
    convertSettings: 'Tetapan Penukaran',
    detected: 'Dikesan',
    convertTo: 'Tukar ke',
    converting: 'Menukar…',
    convertToFormat: 'Tukar ke {format}',
    popularConversions: 'Penukaran Popular',
    convertingTo: 'Menukar ke',
    all: 'Semua',
  },

  resizer: {
    seo: {
      uploadTitle: 'Ubah Saiz Imej — Ubah Saiz JPG, PNG Percuma Dalam Talian | photremium.com',
      uploadDesc: 'Ubah saiz imej mengikut piksel atau peratusan secara percuma dalam talian.',
      uploadKeywords: 'ubah saiz imej, pengubah saiz imej, ubah saiz jpg, ubah saiz png',
      workspaceTitle: 'Mengubah Saiz Imej — photremium.com',
      workspaceDesc: 'Ubah saiz imej secara percuma dalam talian.',
      workspaceKeywords: 'ubah saiz imej, pengubah saiz',
    },
    title: 'Ubah Saiz Imej',
    desc: 'Tentukan saiz dalam piksel, peratusan, sentimeter atau inci dan ubah saiz dengan segera.',
    toResize: 'untuk diubah saiz',
    resizeSettings: 'Tetapan Ubah Saiz',
    resizeBy: 'Ubah saiz mengikut:',
    byPixels: 'Piksel',
    byPercentage: 'Peratusan',
    byCentimeters: 'Sentimeter',
    byInches: 'Inci',
    advanced: 'Lanjutan',
    lockAspect: 'Kunci Nisbah Aspek',
    unlockAspect: 'Buka Kunci Nisbah',
    dontEnlarge: 'Jangan besarkan jika asal lebih kecil',
    resizing: 'Mengubah saiz…',
    resizeDownload: 'Ubah Saiz & Muat Turun',
    blog: {
      tocTitle: 'Kandungan',
      title: 'Blog Pengubah Saiz Imej',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Mengapa menggunakan pengubah saiz imej?',
          paragraphs: [
            'Pengubah saiz imej ialah alat/perisian yang digunakan untuk mengubah dimensi imej. Anda boleh melaras tinggi, lebar atau kedua-duanya untuk mendapatkan saiz yang diperlukan. Ia sangat berguna untuk platform media sosial yang mempunyai had saiz muat naik/siaran.',
          ],
          listTitle: 'Contohnya:',
          bullets: [
            'Siaran Instagram: 1080 x 1080px (segi empat sama)',
            'Siaran Facebook: 1200 x 630px',
            'Siaran X (Twitter): 1200 x 675px',
            'Story Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Mengapa memilih alat pengubah saiz imej kami?',
          paragraphs: [
            'Alat pengubah saiz imej berasaskan AI kami membolehkan anda mengubah saiz imej dengan tepat dan sangat pantas. Ia berfungsi lancar pada mana-mana peranti dan tidak memerlukan pemasangan aplikasi. Semua ciri tersedia terus dalam pelayar anda.',
          ],
          bullets: [
            'Anda boleh mengubah saiz berbilang imej serentak (malah 100+). Jika peranti anda berprestasi tinggi, 400–500 imej juga boleh diproses dalam beberapa saat.',
            'Semua imej diproses dalam pelayar setempat. Tiada muat naik ke pelayan kami dan imej tidak meninggalkan peranti anda, jadi ia selamat untuk imej peribadi.',
            'Unit pengubah saiz berbilang disokong.',
            'Nisbah aspek boleh dikekalkan selepas pengubahan saiz dengan hanya menanda kotak pilihan.',
            'Untuk berbilang imej, anda boleh memuat turun secara berasingan atau sebagai fail ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: 'Mula-mula, pilih imej (satu atau lebih) yang ingin anda ubah saiz. Terdapat beberapa cara untuk memilih imej.',
              bullets: [
                'Anda boleh seret dan lepas imej ke kotak drop untuk diubah saiz.',
                'Anda juga boleh tampal imej dengan pintasan “Ctrl + V”.',
                'Atau klik butang “Choose Files” untuk memilih imej melalui peneroka fail.',
              ],
            },
            {
              heading: 'Seterusnya, pilih unit pengubah saiz. Unit yang tersedia buat masa ini ialah:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Selepas memilih unit, laraskan tinggi dan lebar untuk mengubah saiz imej. Anda juga boleh mengekalkan nisbah aspek menggunakan kotak pilihan.',
            },
            {
              heading: 'Jika anda tidak mahu membesarkan imej melebihi saiz asal, tandakan “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Kemudian pilih salah satu pilihan muat turun.',
              bullets: [
                'Pilih ZIP jika anda mahu semua imej hasil ubah saiz dalam satu fail zip.',
                'Pilih “separate” jika anda mahu setiap imej dimuat turun secara berasingan.',
              ],
            },
            {
              heading: 'Akhir sekali, klik butang “Resize & Download” untuk memuat turun imej mengikut pilihan anda.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Faedah alat pengubah saiz imej: manfaat utama alat ini ialah ia membantu imej dipadankan dengan baik pada halaman web dan siaran media sosial.',
          tocLabel: '4. Faedah alat pengubah saiz imej',
          bullets: [
            'Meningkatkan UX: saiz imej yang betul dan peletakan yang kemas meningkatkan pengalaman pengguna dengan ketara.',
            'Sokongan media sosial: banyak platform mempunyai had dimensi untuk muat naik imej, dan alat ini membantu menyesuaikannya.',
            'Reka bentuk responsif: pembangun web memerlukan pelbagai dimensi imej untuk menyokong pelbagai peranti.',
            'Pilihan terbaik: berbanding meregang atau memotong imej yang boleh menjejaskan rupa, pengubahan saiz biasanya pilihan yang lebih baik.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Format yang disokong: pengubah saiz imej kami menyokong pemilihan imej dalam apa jua format. Format yang disokong disenaraikan di bawah:',
          tocLabel: '5. Format yang disokong',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Potong Imej — Potong JPG, PNG, GIF Percuma Dalam Talian | photremium.com',
      uploadDesc: 'Potong imej JPG, PNG dan GIF dengan mudah secara percuma dalam talian.',
      uploadKeywords: 'potong imej, pemotong imej, potong jpg, potong png',
      workspaceTitle: 'Memotong Imej — photremium.com',
      workspaceDesc: 'Potong imej secara percuma dalam talian.',
      workspaceKeywords: 'potong imej, pemotong',
    },
    title: 'Potong Imej',
    desc: 'Potong JPG, PNG, GIF dan lain-lain dengan editor visual. Nisbah pratetap atau pemotongan bebas.',
    toCrop: 'untuk dipotong',
    cropSettings: 'Tetapan Pemotongan',
    widthPx: 'Lebar (px)',
    heightPx: 'Tinggi (px)',
    positionX: 'Kedudukan X (px)',
    positionY: 'Kedudukan Y (px)',
    cropTemplate: 'Templat Pemotongan',
    landscape: 'Landskap',
    portrait: 'Potret',
    square: 'Segi Empat',
    freeform: 'Bebas',
    cropping: 'Memotong…',
    cropDownload: 'Potong & Muat Turun',
    cropDownloadAll: 'Potong & Muat Turun Semua',
    saveNext: 'Simpan & Seterusnya',
    croppedNofTotal: 'Dipotong {n} daripada {total}.',
    downloadN: 'Muat Turun {n}',
    blog: {
      tocTitle: 'Kandungan',
      title: 'Blog Pemotong Imej',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Mengapa menggunakan alat pemotong imej?',
          paragraphs: [
            'Pemotong imej ialah alat perisian yang digunakan untuk memotong imej kepada bentuk yang dikehendaki. Ia digunakan secara meluas untuk mengekalkan bahagian imej yang diperlukan dan membuang kawasan luar yang tidak diingini bagi apa jua tujuan. Alat ini menyediakan kotak crop yang boleh anda laraskan pada kedudukan yang anda mahu potong.',
          ],
          listTitle: 'Sebagai Contoh:',
          bullets: [
            'Memotong diri anda daripada foto berkumpulan.',
            'Memotong nama anda daripada senarai.',
            'Memotong bar kemajuan daripada tangkapan skrin penuh.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Mengapa memilih pemotong imej kami?',
          paragraphs: [
            'Alat pemotong imej kami membolehkan anda memotong imej dengan tepat dan sangat pantas. Anda hanya perlu melaraskan saiz kotak crop pada kedudukan yang anda mahu potong daripada mana-mana imej. Hampir semua format imej disokong semasa pemilihan imej.',
          ],
          bullets: [
            'Anda boleh memotong sebanyak mana imej yang disokong oleh peranti anda. Jika peranti anda berprestasi tinggi, anda boleh memotong 100+ imej serentak tanpa lag atau isu lain.',
            'Imej anda diproses dalam pelayar setempat anda. Tiada keperluan untuk memuat naik imej ke pelayan kami, jadi tiada imej yang meninggalkan peranti anda. Anda boleh memotong imej peribadi tanpa kebimbangan keselamatan.',
            'Banyak alat memaparkan ralat format imej tidak sah. Pemotong imej kami menyelesaikan isu ini dengan menyokong hampir semua format imej.',
            'Jika anda memotong banyak imej serentak, alat kami membolehkan anda memuat turun imej yang telah dipotong sebagai ZIP atau secara berasingan mengikut pilihan anda.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: '1. Mula-mula, pilih imej yang anda mahu potong. Alat pemotong imej kami juga menyokong pemilihan banyak imej serentak.',
              bullets: [
                'Seret dan lepas imej ke dalam kotak drop untuk dipotong.',
                'Anda juga boleh memilih imej melalui peneroka fail dengan mengklik butang choose files pada kotak crop.',
                'Pintasan Ctrl + V juga disokong untuk menampal imej ke dalam kotak drop.',
              ],
            },
            {
              heading: '2. Kemudian, laraskan saiz dan kedudukan kotak crop pada imej untuk memotongnya.',
            },
            {
              heading: '3. Anda juga boleh melaraskan kotak crop dengan memasukkan nilai tinggi, lebar, kedudukan mendatar dan kedudukan menegak secara manual.',
            },
            {
              heading: '4. Anda juga boleh menggunakan beberapa templat sedia ada:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Kemudian anda perlu memilih salah satu pilihan muat turun.',
              bullets: [
                'ZIP: Pilih pilihan ini jika anda memotong banyak imej dan mahu memuat turun semua imej yang dipotong sebagai satu fail.',
                'Separate: Jika anda mahu memuat turun semua imej yang dipotong secara berasingan, pilih pilihan ini pada butang togol.',
              ],
            },
            {
              heading: '6. Kemudian klik butang Crop & Download untuk memuat turun semua imej yang telah dipotong mengikut dimensi pratetap anda.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Kelebihan Pemotong Imej: alat pemotong imej menawarkan beberapa kelebihan dalam dunia digital. Sebahagiannya diterangkan di bawah:',
          tocLabel: '4. Kelebihan Pemotong Imej',
          bullets: [
            'Melaraskan imej dalam bingkai: Pemotong imej membantu anda meletakkan imej dengan betul dalam bingkai. Bingkai ini boleh berada pada halaman web atau mana-mana platform media sosial.',
            'Meningkatkan UX: Oleh sebab penempatan imej yang baik meningkatkan pengalaman pengguna, pemotong imej membantu meningkatkan UX dengan ketara.',
            'Membuang sempadan tidak diingini: Anda boleh membuang sempadan yang tidak diperlukan daripada imej untuk memperhalusinya.',
            'Mengasingkan objek yang dikehendaki: Anda juga boleh mengasingkan diri anda daripada foto berkumpulan.',
            'Menjimatkan storan: Memotong imej sememangnya menjimatkan storan kerana kawasan mentah imej dibuang dan hanya bahagian yang diperlukan disimpan.',
            'Mengoptimumkan pembentangan: Jika pembentangan biasa dengan 10 imej tidak dipotong menggunakan kira-kira 30MB storan, pembentangan yang sama dengan imej dipotong boleh menggunakan kira-kira 10MB storan.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Format yang disokong:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Editor Foto Dalam Talian — Edit Percuma dengan Teks, Kesan, Bingkai | photremium.com',
      desc: 'Edit foto dalam talian secara percuma — tambah teks, kesan, bingkai, pelekat. Berjalan dalam pelayar.',
      keywords: 'editor foto, editor foto dalam talian, edit foto dalam talian percuma',
    },
    title: 'Editor Foto',
    desc: 'Hiasi foto anda dengan teks, kesan, bingkai dan pelekat.',
    toEdit: 'untuk diedit',
    textTypography: 'Teks & Tipografi',
    textTypographyDesc: 'Tambah teks dengan pelbagai fon, warna, bayang-bayang dan pilihan kedudukan.',
    filtersEffects: 'Penapis & Kesan',
    filtersEffectsDesc: 'Guna penapis profesional dan laraskan kecerahan, kontras dan ketepuan.',
    framesStickers: 'Bingkai & Pelekat',
    framesStickersDesc: 'Pilih bingkai cantik dan pelekat menyeronokkan untuk meningkatkan imej anda.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Buang Latar Belakang Imej Percuma | photremium.com',
      uploadDesc: 'Buang latar belakang imej dengan cepat dan ketepatan tinggi. Pembuang latar belakang dalam talian percuma.',
      uploadKeywords: 'buang latar belakang, pembuang latar belakang, buang latar belakang imej, latar belakang telus',
      workspaceTitle: 'Membuang Latar Belakang — photremium.com',
      workspaceDesc: 'Buang latar belakang imej secara percuma dalam talian.',
      workspaceKeywords: 'buang latar belakang, latar belakang telus',
    },
    title: 'Buang Latar Belakang',
    desc: 'Buang latar belakang imej seketika dengan pengesanan tepi lanjutan. 100% percuma, berjalan dalam pelayar.',
    toRemoveBg: 'untuk dibuang latarnya',
    backgroundRemover: 'Pembuang Latar Belakang',
    processingProgress: 'Kemajuan Pemprosesan',
    processingNImages: 'Memproses {n} imej…',
    allNProcessed: 'Semua {n} imej telah diproses!',
    nOfTotalDone: '{n} / {total} selesai',
    fileName: 'Nama Fail',
    dimensions: 'Dimensi',
    status: 'Status',
    statusDone: '✓ Selesai',
    statusProcessing: '⏳ Memproses',
    statusError: '✗ Ralat',
    statusPending: '⏸ Menunggu',
    badgeDone: 'Selesai',
    badgeProcessing: 'Memproses…',
    badgeError: 'Ralat',
    removingBg: 'Membuang latar belakang…',
    retry: 'Cuba Lagi',
    downloading: 'Memuat turun…',
    nextImage: 'Imej Seterusnya',
  },

  watermark: {
    seo: {
      uploadTitle: 'Tera Air Imej — Tambah Tera Air Teks dan Logo Percuma | photremium.com',
      uploadDesc: 'Tambah tera air teks atau imej pada foto dalam beberapa saat. Percuma, pantas.',
      uploadKeywords: 'tera air imej, tambah tera air, tera air teks',
      workspaceTitle: 'Tera Air Imej — photremium.com',
      workspaceDesc: 'Tambah tera air pada imej secara percuma dalam talian.',
      workspaceKeywords: 'tera air imej, tambah tera air',
    },
    title: 'Tera Air Imej',
    desc: 'Tambah tera air teks atau logo pada imej. Sesuaikan fon, kelegapan, saiz dan kedudukan.',
    toWatermark: 'untuk diberi tera air',
    watermarkTools: 'Alat Tera Air',
    addText: 'Tambah Teks',
    addImage: 'Tambah Imej',
    layersN: 'Lapisan ({n})',
    noLayers: 'Tiada lapisan ditambah lagi',
    textLayer: 'Lapisan Teks',
    imageLayer: 'Lapisan Imej',
    watermarkDownloadAll: 'Beri Tera Air & Muat Turun Semua',
    watermarkDownload: 'Beri Tera Air & Muat Turun',
    nextImage: 'Imej Seterusnya',
    selectToEdit: 'Pilih sebarang imej atau teks untuk mula mengedit',
    bold: 'Tebal',
    italic: 'Condong',
    underline: 'Garis Bawah',
    bgColor: 'Warna Latar',
    textColor: 'Warna Teks',
    alignLeft: 'Rata Kiri',
    alignCenter: 'Rata Tengah',
    alignRight: 'Rata Kanan',
    opacity: 'Kelegapan',
    stroke: 'Strok',
    strokeWidth: 'Lebar Strok',
    strokeColor: 'Warna Strok',
    tileRepeat: 'Jubin/Ulang',
    tilePattern: 'Corak Jubin',
    spacing: 'Jarak',
    snapToCenter: 'Snap ke Tengah',
    duplicate: 'Duplikat',
    delete: 'Padam',
    flipHorizontal: 'Balik Mendatar',
    flipVertical: 'Balik Menegak',
    rotateLeft: 'Putar Kiri',
    rotateRight: 'Putar Kanan',
    cornerRadius: 'Jejari Sudut',
    borderStroke: 'Sempadan/Strok',
    borderWidth: 'Lebar Sempadan',
    color: 'Warna',
    style: 'Gaya',
    hide: 'Sembunyikan',
    show: 'Tunjukkan',
    lock: 'Kunci',
    unlock: 'Buka Kunci',
    solid: 'Pepejal',
    dashed: 'Putus-putus',
    dotted: 'Bertitik',
    double: 'Berganda',
    tileSingle: 'Tunggal',
    tile2x2: 'Grid 2×2',
    tile3x3: 'Grid 3×3',
    removeAllConfirm: 'Buang semua imej dan tera air?',
    dimMismatch: 'Imej yang dimuat naik mempunyai dimensi berbeza. Untuk hasil terbaik, muat naik imej dengan resolusi yang sama.',
    clearBackground: 'Kosongkan Latar Belakang',
    typeHere: 'Taip di sini...',
    linkCorners: 'Pautan Sudut',
    separateCorners: 'Asingkan Sudut',
    blog: {
      tocTitle: 'Kandungan',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Gambaran Keseluruhan Alat Tera Air',
          title: 'Cara Menambah Tera Air pada Imej Anda Dalam Talian — Panduan Lengkap Alat Tera Air Photremium',
          paragraphs: [
            'Anda baru sahaja selesai menyunting sekeping gambar yang indah. Mungkin ia foto produk untuk kedai anda, potret daripada sesi pelanggan, atau karya seni digital yang anda habiskan berjam-jam untuk menyempurnakannya. Dan kini timbul soalan yang akhirnya akan dihadapi oleh setiap pencipta: bagaimana anda melindunginya sebelum berkongsi?',
            'Jawapan yang dipilih oleh kebanyakan profesional ialah tera air — dan ada sebab yang kukuh. Tera air yang diletakkan dengan betul bertindak sebagai tandatangan kekal pada hasil kerja anda, menjadikannya boleh dijejaki, berjenama, dan jauh lebih sukar untuk dicuri.',
            'Masalah yang sering dihadapi kebanyakan orang ialah alat yang tersedia dalam talian sama ada terlalu janggal, dikunci di sebalik langganan, atau menghasilkan tera air yang terlalu berat sehingga merosakkan keseluruhan imej.',
            'Alat Watermark Image Photremium dibina untuk menyelesaikan semua itu. Ia ialah ruang kerja tera air berasaskan pelayar sepenuhnya, percuma, dan tidak memerlukan akaun, yang berjalan terus dalam pelayar anda tanpa memuat naik fail ke pelayan. Semuanya kekal setempat, semuanya kekal pantas, dan tahap kawalan kreatif yang ditawarkannya setanding dengan apa yang anda jangka daripada perisian desktop. Dalam panduan ini, kami akan menunjukkan dengan tepat cara ia berfungsi, untuk siapa ia dibina, dan cara mendapatkan hasil terbaik — setiap kali.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Apa Itu Tera Air',
          title: 'Apa Itu Tera Air dan Mengapa Ia Penting?',
          paragraphs: [
            'Sebelum menyelami alat itu sendiri, ada baiknya memahami apa yang dilakukan oleh tera air dan mengapa ramai jurugambar, pereka, dan pencipta kandungan menganggapnya sesuatu yang tidak boleh dipandang ringan.',
            'Tera air ialah tindihan yang jelas yang ditambah pada imej — biasanya teks, logo, atau simbol hak cipta — yang mengenal pasti pencipta atau pemilik kandungan. Tidak seperti metadata (yang tersembunyi di dalam fail dan boleh dibuang dalam beberapa saat), tera air dibenamkan secara visual ke dalam imej itu sendiri. Anda tidak boleh hanya klik kanan dan membuangnya tanpa menjejaskan kualiti imej dengan ketara.',
          ],
          subSections: [
            {
              title: 'Mengapa Pencipta Menggunakan Tera Air',
              paragraphs: [
                'Sebab praktikal untuk menambah tera air pada imej anda berpunca daripada tiga kebimbangan utama.',
              ],
              bullets: [
                'Pengenalpastian pemilikan. Apabila karya anda dikongsi di platform media sosial, papan Pinterest, atau dibenamkan dalam catatan blog, atribusi asal sering hilang. Tera air memastikan nama atau jenama anda ikut bersama imej ke mana sahaja ia pergi.',
                'Pencegahan kecurian. Kebanyakan pencuri imej biasa mencari jalan paling mudah. Tera air yang kelihatan profesional, terutama yang diletakkan dengan baik dan sedikit telus, menghantar isyarat yang jelas: imej ini milik seseorang yang menghargai hasil kerjanya.',
                'Perlindungan portfolio pelanggan. Jurugambar yang berkongsi pratonton dengan pelanggan sebelum pembayaran akhir kerap menggunakan tera air untuk mengelakkan pelanggan daripada menggunakan pratonton tanpa menyelesaikan invois. Tera air yang halus mencapai tujuan ini tanpa menjadikan pratonton terlalu mengganggu untuk dinilai.',
              ],
            },
            {
              title: 'Siapa Yang Patut Meletakkan Tera Air pada Imej Mereka',
              paragraphs: [
                'Jika anda termasuk dalam mana-mana kategori berikut, meletakkan tera air pada imej anda sebelum berkongsi secara dalam talian bukan pilihan — ia amat penting:',
              ],
              bullets: [
                'Jurugambar bebas yang berkongsi galeri dengan pelanggan',
                'Pereka grafik yang mengedarkan sampel portfolio',
                'Penjual e-dagang yang mempamerkan foto produk sebelum perjanjian pelesenan',
                'Artis digital yang berkongsi karya di platform sosial',
                'Pempengaruh blog dan pencipta kandungan yang imej mereka kerap digunakan semula',
                'Penyumbang foto stok yang membina jenama yang mudah dikenali',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Panel Ruang Kerja',
          title: 'Di Dalam Alat Tera Air Photremium: Ruang Kerja Tiga Panel Dibina untuk Aliran Kerja Sebenar',
          paragraphs: [
            'Apa yang membezakan alat tera air Photremium daripada penanda air dalam talian asas ialah reka bentuk ruang kerjanya. Daripada pendekatan ringkas seperti “taip teks, pilih kedudukan, siap”, alat ini menyediakan susun atur tiga panel yang menyerupai apa yang anda akan temui dalam perisian reka bentuk profesional — cuma ia berjalan sepenuhnya dalam pelayar anda, tanpa pemasangan diperlukan.',
          ],
          subSections: [
            {
              title: 'Panel Kanvas Kiri',
              paragraphs: [
                'Panel kanvas mengambil bahagian terbesar skrin dan memaparkan dengan tepat rupa imej anda selepas tera air digunakan dalam masa nyata. Setiap perubahan yang anda buat — melaraskan kelegapan, mengubah kedudukan lapisan teks, mengubah saiz logo — dipaparkan serta-merta pada kanvas. Tiada butang “pratonton” untuk diklik. Apa yang anda lihat ialah apa yang anda dapat.',
                'Kanvas juga mempunyai bar alat zum terbina dalam, membolehkan anda zum masuk untuk penjajaran tepat dan zum keluar untuk melihat gambaran besar. Ciri zum-untuk-sesuai mengira skala awal terbaik secara automatik berdasarkan saiz skrin anda, jadi walaupun imej resolusi tinggi dimuatkan pada saiz kerja yang selesa. Panduan penjajaran muncul secara dinamik apabila anda menyeret lapisan berhampiran tengah mendatar atau menegak imej, memakukan tera air ke kedudukan yang benar-benar berpusat dengan ketepatan memuaskan yang biasanya hanya anda dapat daripada Photoshop.',
              ],
            },
            {
              title: 'Panel Tetapan Kanan',
              paragraphs: [
                'Panel kanan ialah pusat kawalan. Di sinilah anda mengurus lapisan tera air, menyesuaikan penampilannya, dan mencetuskan eksport akhir. Pada desktop, ia kekal tetap di sebelah kanan skrin. Pada peranti mudah alih, ia muncul dari bawah sebagai helaian bawah — dicetuskan oleh butang gear terapung — supaya ia tidak menutup kanvas anda ketika anda bekerja.',
                'Dalam panel kanan anda akan menemui pengurus lapisan, yang menyenaraikan setiap elemen tera air yang telah anda tambahkan. Setiap entri lapisan menunjukkan jenis lapisan (teks atau imej), nama atau kandungan semasanya, dan tiga butang tindakan pantas: suis keterlihatan (ikon mata), suis kunci untuk membekukan kedudukan lapisan semasa anda bekerja pada lapisan lain, dan butang padam.',
              ],
            },
            {
              title: 'Jalur Pratonton Kiri (Mod Berbilang Imej)',
              paragraphs: [
                'Apabila anda bekerja dengan berbilang imej serentak — satu kelompok foto produk, atau satu sesi potret penuh — jalur lakaran kecil menegak muncul di paling kiri skrin. Ini ialah barisan imej, yang memaparkan pratonton mini bagi setiap fail yang anda muatkan. Mengklik mana-mana lakaran kecil menukar kanvas anda kepada imej itu serta-merta, membolehkan anda mengesahkan rupa tera air merentasi komposisi yang berbeza tanpa kehilangan tetapan lapisan anda.',
                'Jalur ini juga memaparkan bacaan saiz dalam KB atau MB bagi setiap fail, bersama label format fail (JPG, PNG, WEBP), supaya anda sentiasa tahu apa yang sedang anda gunakan sekilas pandang.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Langkah Demi Langkah',
          title: 'Langkah Demi Langkah: Cara Menambah Tera Air pada Imej Anda di Photremium',
          paragraphs: [
            'Panduan ini berdasarkan terus pada cara alat ini berfungsi di belakang tabir — daripada sistem muat naik seret dan lepas hinggalah kepada enjin rendering kanvas yang menulis tera air anda secara kekal pada imej sebelum muat turun.',
          ],
          steps: [
            {
              heading: 'Langkah 1 — Muat Naik Imej Anda',
              paragraphsBefore: [
                'Pergi ke photremium.com/watermark-image. Anda akan tiba pada skrin muat naik, yang memaparkan zon seret dan lepas yang kemas di tengah halaman.',
                'Anda mempunyai tiga cara untuk membawa imej anda ke dalam alat ini:',
              ],
              bullets: [
                'Seret dan lepas. Seret satu atau lebih fail imej dari desktop anda terus ke zon drop. Alat ini menerima sebarang format imej standard — JPEG, PNG, WEBP, dan banyak lagi. Apabila anda menyeret fail ke atas ruang kerja, sempadan ungu akan diaktifkan di sekeliling keseluruhan kawasan dengan arahan visual “Drop images to add for watermarking”, jadi anda tahu tindakan lepasan itu telah dikesan.',
                'Klik untuk semak imbas. Klik butang “Choose Files” di dalam zon drop untuk membuka pemilih fail sistem anda. Anda boleh memilih berbilang fail sekaligus menggunakan Ctrl+Click (Windows) atau Cmd+Click (Mac).',
                'Tampal daripada papan keratan. Jika anda telah menyalin imej ke papan keratan — daripada tangkapan skrin, aplikasi lain, atau pelayar web — hanya tekan Ctrl+V (atau Cmd+V pada Mac) semasa berada pada halaman tera air dan imej akan dimuatkan terus ke dalam ruang kerja. Ini berfungsi walaupun beberapa imej sudah dimuatkan.',
              ],
              paragraphsAfter: [
                'Sebaik sahaja imej pertama dimuatkan, ruang kerja beralih daripada skrin muat naik kepada editor penuh tiga panel, dan kanvas memaparkan imej anda pada tahap zum muat-ikut-skrin yang dikira secara automatik.',
              ],
            },
            {
              heading: 'Langkah 2 — Tambah Lapisan Tera Air Teks',
              paragraphsBefore: [
                'Klik butang ungu “Add Text” dalam panel kanan. Lapisan teks baharu akan muncul pada kanvas anda dengan teks pemegang letak lalai “Type here...” telah dipilih.',
                'Anda boleh mula menaip serta-merta. Teks dipaparkan secara langsung pada kanvas dalam Arial putih pada saiz lalai yang ditala mengikut dimensi imej anda. Daripada bar alat atas yang muncul apabila lapisan teks dipilih, anda boleh menyesuaikan setiap aspek teks:',
              ],
              bullets: [
                'Keluarga fon — pilih daripada 12 fon terbina dalam termasuk Arial, Georgia, Impact, Brush Script MT, Comic Sans MS, dan banyak lagi',
                'Saiz fon — taip nilai piksel tersuai secara langsung atau gunakan kawalan tambah/tolak',
                'Tebal, condong, garis bawah — hidupkan mana-mana gabungan gaya ini',
                'Warna teks — klik swatch warna untuk membuka pemilih warna dan pilih sebarang warna hex',
                'Warna latar — tambah latar berwarna di belakang teks anda untuk rupa label atau lencana',
                'Stroke (garis luar) — tetapkan lebar dan warna stroke untuk kebolehbacaan maksimum pada imej cerah dan gelap',
                'Kelegapan — laraskan dari 0% (tidak kelihatan) hingga 100% (legap sepenuhnya); kebanyakan tera air berada antara 30% dan 60%',
                'Penjajaran — rata kiri, tengah, atau kanan teks dalam kotak sempadannya',
                'Putaran — putar lapisan teks ke mana-mana sudut, dengan titik snap magnetik pada 0°, 90°, 180°, dan 270° untuk peletakan sudut tepat yang pantas',
              ],
              paragraphsAfter: [
                'Untuk menggerakkan teks, klik dan seretnya ke mana-mana pada kanvas. Untuk kedudukan tepat per piksel, gunakan kekunci anak panah pada papan kekunci anda (tahan Shift untuk langkah 10 piksel). Untuk mengubah saiz kotak teks, seret mana-mana daripada lapan pemegang ubah saiz (sudut dan tepi) yang muncul di sekeliling lapisan yang dipilih.',
              ],
            },
            {
              heading: 'Langkah 3 — Tambah Lapisan Tera Air Imej (Logo)',
              paragraphsBefore: [
                'Jika anda mahu menggunakan logo, tandatangan, atau sebarang imej sebagai tera air dan bukannya — atau sebagai tambahan kepada — teks, klik butang biru “Add Image” dalam panel kanan. Pemilih fail anda akan dibuka supaya anda boleh memilih fail imej tera air dari peranti anda.',
                'Alat ini secara automatik mensaiz imej tera air kepada kira-kira 30% daripada lebar kanvas anda sambil mengekalkan nisbah aspek asalnya, dan memusatkannya pada kanvas. Dari situ, anda boleh menyeretnya ke mana-mana kedudukan, mengubah saiznya menggunakan pemegang sudut (yang mengekalkan nisbah aspek), atau memutarkannya menggunakan pemegang putar khusus yang muncul di atas lapisan yang dipilih.',
                'Bagi lapisan tera air jenis imej, panel kanan memaparkan kawalan tambahan:',
              ],
              bullets: [
                'Kelegapan — sama seperti lapisan teks, sesuai untuk logo PNG telus',
                'Flip mendatar / Flip menegak — cerminkan tera air jika perlu',
                'Lebar sempadan, warna sempadan, dan gaya sempadan — tambah sempadan yang kelihatan di sekeliling tera air logo',
                'Jejari sempadan — bulatkan bucu tera air logo, sama ada secara seragam atau dengan kawalan berasingan untuk setiap bucu',
                'Putaran — tingkah laku putaran yang sama lancar seperti lapisan teks',
              ],
            },
            {
              heading: 'Langkah 4 — Konfigurasikan Tiling (Pilihan)',
              paragraphsBefore: [
                'Salah satu ciri yang lebih berkuasa dalam alat ini ialah tiling — keupayaan untuk mengulang tera air anda merentasi keseluruhan imej dalam corak grid. Ini sangat berguna apabila anda mahu menjadikan imej tidak dapat digunakan untuk penerbitan semula, bukannya sekadar berjenama.',
                'Dengan lapisan yang dipilih, cari pilihan tile dalam bar alat. Anda boleh menetapkannya kepada:',
              ],
              bullets: [
                'None — peletakan tunggal (lalai)',
                'Grid 2×2 — mengulang tera air dalam corak 2 lajur, 2 baris',
                'Grid 3×3 — mengulang dalam grid 3×3 untuk liputan yang lebih padat',
              ],
              paragraphsAfter: [
                'Anda juga boleh melaraskan jarak tile, yang mengawal ruang antara setiap pengulangan. Kanvas memaparkan pratonton bayangan bagi semua salinan bertile supaya anda dapat melihat corak liputan penuh sebelum memuat turun.',
              ],
            },
            {
              heading: 'Langkah 5 — Gunakan Pengurus Lapisan untuk Berbilang Tera Air',
              paragraphsBefore: [
                'Anda boleh menambah seberapa banyak lapisan yang anda mahu — menggabungkan tera air teks dan imej sesuka hati. Pengurus lapisan dalam panel kanan menyenaraikan semuanya. Anda boleh:',
              ],
              bullets: [
                'Tunjuk/sembunyikan lapisan individu menggunakan ikon mata — berguna untuk menukar antara versi tera air yang berbeza tanpa memadam apa-apa',
                'Kunci lapisan untuk mengelakkan kedudukan berubah secara tidak sengaja semasa anda bekerja pada lapisan lain',
                'Padam lapisan secara kekal',
              ],
              paragraphsAfter: [
                'Mengklik mana-mana entri lapisan dalam senarai akan memilihnya pada kanvas pada masa yang sama, menjadikannya mudah untuk bertukar antara lapisan tanpa perlu mencari-cari pada imej.',
              ],
            },
            {
              heading: 'Langkah 6 — Tukar Antara Berbilang Imej',
              paragraphsBefore: [
                'Jika anda memuat naik lebih daripada satu imej, gunakan jalur lakaran kecil di sebelah kiri untuk menukar imej kanvas aktif anda. Lapisan tera air yang anda konfigurasikan akan digunakan secara universal — ia akan dirender pada setiap imej dalam kelompok anda apabila anda mengeksport.',
                'Alat ini juga melakukan semakan keseragaman resolusi merentasi kelompok anda. Jika imej anda mempunyai dimensi yang jauh berbeza (lebih daripada 5% perbezaan pada lebar atau tinggi), satu amaran akan muncul dan memberitahu anda bahawa kedudukan tera air mungkin kelihatan berbeza antara imej akibat variasi saiz. Enjin ini mengendalikannya dengan baik melalui algoritma kedudukan semula berkadar: ia mengira kedudukan tera air sebagai peratusan dimensi imej rujukan dan menggunakan peletakan berkadar yang sama pada setiap imej lain dalam kelompok, mengekalkan niat visual walaupun pada resolusi yang berbeza.',
              ],
            },
            {
              heading: 'Langkah 7 — Tetapkan Keutamaan Muat Turun Anda',
              paragraphsBefore: [
                'Bagi kerja satu imej, klik butang “Download” di bawah kanvas untuk menyimpan imej bertera air terus. Nama fail akan ditetapkan secara automatik kepada nama fail asal anda dengan “-watermarked” ditambah sebelum sambungan. Imej JPEG dieksport pada kualiti 0.95 — cukup tinggi sehingga tidak dapat dibezakan daripada asal pada saiz tontonan biasa. Imej PNG dieksport sebagai PNG tanpa kehilangan data.',
                'Bagi kerja kelompok (berbilang imej), anda mempunyai dua mod muat turun yang boleh dipilih dalam panel kanan:',
              ],
              bullets: [
                'Fail ZIP — semua imej bertera air dibungkus dalam satu arkib ZIP yang dimuat turun dengan satu klik. Alat ini memuatkan JSZip secara dinamik untuk mengendalikan pemampatan.',
                'Fail berasingan — setiap imej dimuat turun sebagai fail individu dengan kelewatan singkat antara setiap muat turun untuk mengelakkan pembatasan pelayar.',
              ],
            },
            {
              heading: 'Langkah 8 — Muat Turun dan Sahkan',
              paragraphsBefore: [
                'Selepas mengklik butang muat turun (atau butang “Watermark & Download All” untuk kelompok), alat ini merender setiap imej pada elemen HTML5 canvas tersembunyi pada resolusi asli penuh — bukan pada saiz pratonton berskala yang anda lihat pada skrin. Ini bermakna imej yang dieksport berada pada 100% dimensi piksel asalnya dengan tera air dilukis pada saiz yang betul secara berkadar. Buka fail yang dimuat turun dan zum masuk untuk mengesahkan peletakan serta kualiti tera air sepadan dengan jangkaan anda.',
                'Jika ada apa-apa yang kelihatan tidak betul, hanya kembali ke ruang kerja — lapisan anda masih ada — laraskan, dan muat turun semula.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Petua Pro',
          title: 'Petua Pro untuk Mendapatkan Hasil Terbaik',
          bullets: [
            'Gunakan logo PNG separa telus untuk rupa yang paling profesional. Tera air logo dengan latar belakang lutsinar pada kelegapan 40–50% kelihatan jauh lebih kemas daripada teks pepejal. Eksport logo anda daripada alat reka bentuk sebagai PNG dengan ketelusan alfa sebelum menggunakannya sebagai lapisan imej.',
            'Letakkan tera air anda di tempat di mana pemotongan akan mengurangkan nilainya. Sudut kanan bawah ialah peletakan tera air yang paling biasa — dan yang paling mudah untuk dipotong keluar. Untuk perlindungan yang lebih kuat, pertimbangkan meletakkan tera air anda merentasi kawasan imej yang penting secara visual, seperti pada wajah, butiran produk, atau titik fokus. Pilihan tile diagonal lebih sukar untuk dibuang tanpa merosakkan imej dengan ketara.',
            'Gunakan ciri kunci apabila bekerja dengan berbilang lapisan. Setelah anda berpuas hati dengan kedudukan tera air utama anda, kunci lapisan itu sebelum menambah lapisan sekunder. Ini mengelakkan anda tersalah anjak semasa bekerja pada elemen lain.',
            'Uji pada kawasan terang dan gelap imej anda. Tera air putih tidak kelihatan pada langit cerah tetapi jelas dibaca pada bayang-bayang gelap. Tambahkan stroke halus atau warna latar untuk memastikan kebolehbacaan tanpa mengira apa yang terdapat di bawah tera air.',
            'Pintasan papan kekunci sentiasa menjimatkan masa. Kekunci anak panah menggerakkan lapisan terpilih satu piksel pada satu masa. Shift+Arrow menggerakkan sepuluh piksel pada satu masa. Kekunci Delete membuang lapisan terpilih serta-merta. Pintasan ini menjadikan pelarasan kedudukan yang halus jauh lebih pantas daripada menyeret.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privasi dan Keselamatan',
          title: 'Privasi dan Keselamatan: Mengapa Pemprosesan Berasaskan Pelayar Penting',
          paragraphs: [
            'Satu kebimbangan yang dimiliki ramai pencipta apabila menggunakan alat dalam talian ialah ke mana sebenarnya imej mereka pergi. Dengan alat tera air berasaskan pelayan, imej anda dimuat naik ke pelayan penyedia, diproses di sana, kemudian dihantar kembali kepada anda. Ini bermakna karya yang belum diterbitkan, foto pelanggan, atau imej produk sensitif anda melalui infrastruktur pihak lain.',
            'Alat tera air Photremium memproses semuanya secara setempat dalam pelayar anda. Imej anda dimuatkan ke dalam memori peranti anda menggunakan File API pelayar dan tidak pernah dihantar melalui internet. Penerapan tera air berlaku pada elemen HTML5 canvas yang berjalan dalam JavaScript, sepenuhnya dalam tab pelayar anda. Apabila anda menutup halaman atau klik “Start Over,” semua data imej dilepaskan daripada memori dan dibuang. Tiada apa-apa disimpan di luar peranti anda sendiri.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Ringkasan Akhir',
          title: 'Mengapa Alat Tera Air Photremium Layak Menjadi Sebahagian daripada Aliran Kerja Biasa Anda',
          paragraphs: [
            'Terdapat berpuluh-puluh alat tera air yang tersedia dalam talian. Apa yang membezakan alat yang wajar ditanda buku daripada yang wajar dilupakan biasanya ialah gabungan kelajuan, kawalan, dan kebolehpercayaan.',
            'Kelajuan penting kerana proses tera air tidak sepatutnya menambah masa yang ketara pada aliran kerja pascapemprosesan anda. Alat Photremium dimuatkan serta-merta, memproses secara setempat, dan mengeksport pada resolusi penuh dalam beberapa saat — walaupun untuk kelompok besar. Tiada menunggu pemprosesan di sisi pelayan, tiada barisan, dan tiada masa rendering yang meningkat mengikut bilangan pengguna yang berada dalam talian pada masa yang sama.',
            'Kawalan penting kerana tera air yang kelihatan salah lebih teruk daripada tiada tera air langsung — ia membuatkan jenama anda kelihatan tidak profesional. Sistem lapisan, kawalan per sifat dalam bar alat, pratonton kanvas masa nyata, dan sokongan pintasan papan kekunci semuanya memberikan tahap kawalan yang benar-benar setanding dengan perisian desktop khusus.',
            'Kebolehpercayaan penting kerana karya yang belum diterbitkan sangat bernilai. Mengetahui bahawa imej anda tidak pernah bergerak melalui internet ke pelayan pihak ketiga bermakna anda boleh menanda air foto pelanggan, imej produk yang belum dilancarkan, dan karya kreatif sensitif tanpa sebarang kebimbangan tentang pengendalian data, pelanggaran di sisi pelayan, atau perubahan dasar oleh penyedia awan.',
            'Sama ada anda menambah notis hak cipta pantas pada satu foto atau memproses keseluruhan sesi 200 imej sebelum berkongsi galeri pelanggan, alat Watermark Image Photremium memberi anda alat untuk melakukannya dengan betul — sepenuhnya percuma, sepenuhnya peribadi, dan cukup fleksibel dari segi kreatif untuk menjadikan tera air kelihatan seolah-olah memang sepatutnya berada pada imej, bukan sekadar ditampal di atasnya.',
            'Pergilah ke photremium.com/watermark-image dan cubalah. Imej bertera air pertama anda benar-benar hanya tiga puluh saat lagi.',
            'Photremium menawarkan rangkaian alat penyuntingan dan pemprosesan imej berasaskan pelayar. Semua alat berjalan secara setempat dalam pelayar anda — imej anda kekal pada peranti anda.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Penjana Kod QR — Jana dan Sesuaikan Percuma | photremium.com',
      inputDesc: 'Jana kod QR tersuai untuk URL, teks, WiFi, kenalan, e-mel dan Google Maps.',
      inputKeywords: 'penjana kod qr, buat kod qr, kod qr tersuai',
      customizeTitle: 'Sesuaikan Kod QR — photremium.com',
      customizeDesc: 'Sesuaikan gaya, warna, bingkai dan logo kod QR anda. Muat turun sebagai PNG, JPG, SVG, WEBP atau PDF.',
      customizeKeywords: 'sesuaikan kod qr, gaya kod qr',
    },
    title: 'Penjana Kod QR',
    desc: 'Jana, sesuaikan dan muat turun kod QR untuk URL, teks, WiFi, kenalan, e-mel dan peta.',
    generate: 'Jana',
    scanQrCode: 'Imbas Kod QR',
    tabUrl: 'Pautan / URL',
    tabText: 'Teks',
    tabWifi: 'WiFi',
    tabContact: 'Kenalan',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Masukkan URL',
    enterText: 'Masukkan teks',
    networkName: 'Nama Rangkaian (SSID)',
    password: 'Kata Laluan',
    encryption: 'Penyulitan',
    hiddenNetwork: 'Rangkaian Tersembunyi',
    contactName: 'Nama Kenalan (pilihan)',
    phoneNumber: 'Nombor Telefon',
    emailAddress: 'Alamat E-mel',
    subject: 'Subjek (pilihan)',
    body: 'Isi (pilihan)',
    searchLocation: 'Cari lokasi',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Taip teks anda di sini…',
    wifiNamePlaceholder: 'WiFi Saya',
    passwordPlaceholder: 'kata laluan',
    contactPlaceholder: 'Ahmad bin Abdullah',
    phonePlaceholder: '+60 12 345 6789',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'subjek',
    bodyPlaceholder: 'isi e-mel…',
    locationPlaceholder: 'Cari bandar, alamat, tempat…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Tiada',
    characters: 'aksara',
    generateCustomize: 'Jana & Sesuaikan',
    editQrData: 'Edit Data QR',
    styleShape: 'Gaya & Bentuk',
    colorTab: 'Warna',
    framesTab: 'Bingkai',
    logoTab: 'Logo',
    templatesTab: 'Templat',
    fileFormatTab: 'Format Fail',
    fgColor: 'Warna Hadapan',
    bgColor: 'Warna Latar',
    enableGradient: 'Aktifkan Kecerunan',
    gradientType: 'Jenis Kecerunan',
    linear: 'Linear',
    radial: 'Radial',
    selectFrame: 'Pilih Bingkai',
    selectLogo: 'Pilih Logo',
    uploadCustomLogo: 'atau muat naik logo tersuai',
    uploadImage: 'Muat Naik Imej',
    downloadFormat: 'Format Muat Turun',
    preview: 'Pratonton',
    downloadFormatBtn: 'Muat Turun {format}',
    pngDesc: 'Tanpa kehilangan, sokongan ketelusan',
    jpgDesc: 'Format fail popular/universal',
    webpDesc: 'Format moden, kualiti/saiz terbaik',
    svgDesc: 'Grafik vektor boleh skala',
    pdfDesc: 'Dokumen sedia cetak',
    lat: 'Latitud:',
    lng: 'Longitud:',
    qrCode: 'Kod QR',
    scanMe: 'Imbas Saya',
    scanHere: 'Imbas Di Sini',
    blog: {
      card1: {
        title: '1. Apakah itu kod QR?',
        intro1: 'Bentuk lengkap kod QR adalah "Quick Response code" (kod sambutan pantas). Kerana maklumat yang disimpan dalam ia didekod dengan sangat pantas, ia dipanggil kod Quick Response (QR).',
        intro2: 'Kod QR ialah kod digital dua dimensi yang hanya boleh dibaca oleh mesin. Data di dalamnya tidak boleh dibaca oleh manusia. Ia mengandungi blok untuk menyimpan maklumat seperti teks, nombor telefon, pautan dan lokasi peta Google, dll.',
        inventionTitle: 'Bagaimana kod QR dimulai:',
        inventionText: 'Kod QR diciptakan pada tahun 1994. Masahiro Hara dan pasukannya bekerja di sebuah syarikat Jepun bernama Denso Wave, yang membuat bahagian kereta untuk Toyota. Mereka mahukan kod yang menyimpan lebih banyak maklumat daripada barcode biasa, kemudian mereka mencipta kod QR.',
        keyFeaturesTitle: 'Ciri-ciri utama kod QR',
        keyFeatures: [
          {
            title: 'Bagaimana QR berfungsi',
            text: 'Anda memasukkan teks atau pautan untuk menjana kod QR. Penjana QR membuat kotak segi empat mengikut maklumat. Setiap kotak mewakili satu bit, dan setiap bit menyimpan satu aksara.',
          },
          {
            title: 'Struktur kod QR',
            text: 'Kod QR mengandungi tiga kotak segi empat besar untuk mengenal pasti orientasi kod QR, dan satu kotak segi empat kecil untuk menyimpan bit (maklumat).',
          },
          {
            title: 'Kapasiti Data kod QR',
            text: 'Biasanya, kod QR menyimpan lebih banyak maklumat daripada barcode. Kod QR hanyalah versi canggih barcode. Ia pada dasarnya adalah barcode dua dimensi. Kod QR menyimpan hampir 200 aksara. Ia juga boleh menyimpan 400 aksara tetapi sukar diimbas. Menyimpan lebih daripada 400 aksara mungkin menghasilkan kod QR yang sangat kompleks yang hampir tidak boleh diimbas.',
          },
          {
            title: 'Pengesanan Ralat dalam Kod QR',
            text: 'Kod QR masih boleh diimbas jika beberapa maklumat padanya tercanit atau beberapa bit dibalikkan. Kod QR menggunakan teknik pengesanan ralat Reed-Solomon untuk mengesan ralat, dan menyelesaikannya selepas pengenalan.',
          },
        ],
        errorTitle: 'Tahap pembetulan ralat kod QR:',
        errorIntro: 'Teknik pengesanan dan pembetulan ralat yang berbeza digunakan dalam kes yang berbeza seperti yang dijelaskan di bawah:',
        errorHeaders: {
          level: 'Tahap',
          recovery: 'Kapasiti pemulihan',
          bestUse: 'Kes penggunaan terbaik',
        },
        errorRows: [
          {
            level: 'Rendah (L)',
            recovery: '~7%',
            useCases: [
              'Teknik pembetulan ralat ini digunakan apabila kod QR dipaparkan pada skrin digital, laman web, atau dalam persekitaran yang bersih.',
              'Apabila kod QR dijana untuk maklumat kecil seperti Gmail, nombor kenalan, atau teks kecil.',
            ],
          },
          {
            level: 'Sederhana (M)',
            recovery: '~15%',
            useCases: [
              'Untuk risalah dan poster yang dipasang dalam persekitaran bersih, dan ketika risiko kerosakan boleh diabaikan.',
            ],
          },
          {
            level: 'Kuartil (Q)',
            recovery: '~25%',
            useCases: [
              'Apabila kod QR perlu dipasang dalam persekitaran yang keras seperti di kilang/luar.',
              'Juga, apabila logo kecil diperlukan di tengah, ia meliputi beberapa bit. Jadi, teknik pembetulan ralat ini diperlukan.',
            ],
          },
          {
            level: 'Tinggi (H)',
            recovery: '~30%',
            useCases: [
              'Digunakan apabila kerosakan berat pada kod QR mungkin berlaku.',
              'Apabila logo besar meliputi pusat kod QR.',
              'Juga, apabila penggayaan berat diperlukan untuk kod QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Mengapa memilih penjana kod QR kami?',
        intro: 'Penjana kod QR kami menjadikan penjanaan kod QR sangat pantas, selamat, dan mudah. Anda boleh menyesuaikan kod anda untuk menjadikannya lebih canggih, profesional, dan sesuai dengan tema perniagaan anda. Semua penyesuaian dari pewarnaan kod QR hingga pemasangan logo dalam kod QR ditawarkan secara percuma selamanya.',
        strengths: [
          {
            title: 'Penyesuaian Profesional:',
            text: 'Anda boleh menjana dan menyesuaikan seberapa banyak kod QR seperti yang anda perlukan tanpa sebarang kos. Semua ciri sepenuhnya percuma. Anda boleh menggunakan warna kecerunan, bentuk berbeza untuk kotak segi empat, logo tersuai, dan banyak ciri lain.',
          },
          {
            title: 'Sokongan format berbilang:',
            text: 'Penjana kod QR kami menawarkan berbilang format muat turun untuk kemudahan anda. Anda hanya perlu memilih format pilihan anda sebelum memuat turun. Pada masa ini kami menawarkan format ini:',
          },
          {
            title: 'Templat pra-siap:',
            text: 'Anda boleh menggunakan warna kecerunan pra-siap dan bingkai yang menjadikan kod QR anda profesional.',
          },
          {
            title: 'Sokongan logo tersuai:',
            text: 'Anda juga boleh memuat naik logo jenama tersuai anda yang sesuai secara automatik di tengah kod QR. Anda juga boleh memilih logo dari perpustakaan logo terbina di mana lebih daripada 30 logo disediakan.',
          },
          {
            title: 'Pratonton Langsung:',
            text: 'Semasa menyesuaikan, anda boleh menonton semua perubahan dalam panel pratonton langsung. Perubahan ini dalam panel pratonton adalah masa nyata yang berubah secara dinamik.',
          },
          {
            title: 'Penunjuk Imbasan:',
            text: 'Semasa memilih warna, amaran dan penunjuk yang sesuai membimbing anda jika anda memilih warna yang sukar diimbas.',
          },
        ],
        formatHeaders: {
          srNo: 'Bil.',
          formats: 'Format',
          description: 'Perihalan',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Tanpa kehilangan, sokongan ketelusan' },
          { no: '2', format: 'JPG', description: 'Popular, format fail universal' },
          { no: '3', format: 'WEBP', description: 'Moden, kualiti/saiz terbaik' },
          { no: '4', format: 'SVG', description: 'Grafik vektor boleh skala' },
          { no: '5', format: 'PDF', description: 'Dokumen sedia cetak' },
        ],
      },
      card3: {
        title: '3. Panduan langkah demi langkah:',
        step1Intro: 'Pertama sekali, pilih kategori kod QR yang anda ingin jana. Sama ada anda menjana kod QR untuk kenalan, Peta, pautan atau teks. Pada masa ini, penjana kod QR kami menawarkan kategori ini:',
        categories: ['Pautan / URL', 'Teks', 'WiFi', 'Kenalan', 'Gmail', 'Google Maps'],
        step2: 'Selepas memilih kategori, tampal maklumat anda dalam kotak teks mengikutnya.',
        step3Intro: 'Kemudian, klik pada Jana & Sesuaikan untuk membuka panel penyesuaian. Dalam panel penyesuaian, anda akan melihat bar navigasi sub dengan pilihan berikut:',
        options: [
          {
            title: 'Gaya & Bentuk:',
            text: 'Dalam bahagian ini, anda boleh menukar bentuk kotak segi empat kepada pelbagai gaya seperti sudut bulat, titik, bar mendatar, bar menegak, kotak kecil, dan banyak yang lain.',
          },
          {
            title: 'Warna:',
            text: 'Anda boleh memilih warna latar dan hadapan tersuai dalam bahagian ini. Untuk menjadikan kod QR anda dalam warna kecerunan, anda mempunyai pilihan untuk membolehkan kecerunan yang membenarkan anda menggunakan sebarang warna kecerunan dari perpustakaan terbina atau membuat warna kecerunan anda sendiri dengan mudah. Anda juga boleh menukar sudut untuk warna kecerunan linear. Kecerunan radial juga disokong. Anda boleh menambah berbilang warna untuk membuat kesan kecerunan profesional.',
          },
          {
            title: 'Bingkai:',
            text: 'Di sini, anda boleh memilih bingkai sempurna untuk kod QR anda. Semua bingkai secara automatik sesuai dengan kod anda secara automatik. Anda hanya perlu memilih bingkai dari perpustakaan terbina.',
          },
          {
            title: 'Logo:',
            text: 'Selepas pemilihan bingkai, anda boleh memilih logo yang secara automatik diselaraskan di tengah kod QR. Memuat naik logo jenama tersuai anda juga disokong.',
          },
          {
            title: 'Templat:',
            text: 'Jika anda tidak ingin memilih gaya, bentuk, warna dan bingkai secara berasingan, anda boleh menggunakan templat pra-siap pada kod QR anda. Berbilang templat premium disediakan untuk kemudahan anda yang percuma selamanya.',
          },
          {
            title: 'Format Fail:',
            text: 'Akhir sekali, anda perlu memilih jenis fail yang anda ingin muat turun kod QR. Beberapa format biasa disokong termasuk PNG, WEBP, SVG, dan PDF, dll.',
          },
          {
            title: 'Edit Data QR:',
            text: 'Anda juga boleh mengedit data QR anda tanpa sebarang kehilangan dalam penyesuaian anda yang dipilih.',
          },
        ],
        finalStep: 'Kemudian, hanya klik pada butang muat turun, dan kod QR tepat mengikut penyesuaian anda dan dalam format yang dipilih akan dimuat turun serta-merta tanpa sebarang kos.',
      },
      card4: {
        title: '4. Faedah:',
        intro: 'Kod QR menyambungkan dunia fizikal dengan pengalaman digital. Ia adalah cara paling pantas untuk berkongsi pautan, kenalan, atau lokasi anda. Anda hanya perlu mengimbas kod QR tersebut untuk mengakses maklumat dengan serta-merta. Jadi, ia sangat popular dalam perniagaan dan dunia digital kerana cekap masa dan sangat berpurposa.',
        benefits: [
          {
            title: 'Sokongan Seumur Hidup:',
            text: 'Kod QR berfungsi selamanya tanpa sebarang tamat tempoh. Mereka memberikan anda maklumat yang disimpan dengan serta-merta apabila anda mengimbasnya. Kerana ia menyimpan arahan digital berkod keras, ia tidak pernah kehilangan maklumatnya.',
          },
          {
            title: 'Sokongan Luar Talian:',
            text: 'Anda boleh mengimbas kod QR walaupun anda berada dalam talian. Kamera mudah alih anda mentafsir corak kod QR dan memberikan anda maklumat yang disimpan di dalamnya.',
          },
          {
            title: 'Kos Sifar:',
            text: 'Kerana kod ini tidak memerlukan sebarang pengalihan pelayan atau sumber, ia bebas kos selamanya.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Pengimbas Kod QR — Imbas Kod QR dari Kamera atau Imej | photremium.com',
      desc: 'Imbas kod QR seketika menggunakan kamera atau muat naik imej. Kesan URL, teks, WiFi, kenalan dan lain-lain.',
      keywords: 'pengimbas kod qr, imbas kod qr, pembaca qr, kod qr dalam talian',
    },
    title: 'Pengimbas Kod QR',
    desc: 'Imbas kod QR seketika menggunakan kamera atau muat naik imej. Pantas dan selamat.',
    generateQrCode: 'Jana Kod QR',
    scan: 'Imbas',
    cameraScanner: 'Pengimbas Kamera',
    uploadImage: 'Muat Naik Imej',
    pointCamera: 'Arahkan kamera ke kod QR',
    startCamera: 'Mulakan Kamera',
    loading: 'Memuatkan…',
    dropQrImage: 'Lepaskan imej kod QR di sini',
    toScan: 'untuk diimbas',
    supportedFormats: 'Sokong JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Tampal dengan Ctrl+V',
    scanFromGallery: 'Imbas dari Galeri',
    instantScanning: 'Imbasan Segera',
    instantScanningDesc: 'Pengesanan kod QR masa nyata daripada kamera atau imej yang dimuat naik',
    private100: '100% Peribadi',
    private100Desc: 'Semua pemprosesan berlaku dalam pelayar anda. Tiada apa-apa dimuat naik',
    multiFormat: 'Pelbagai Format',
    multiFormatDesc: 'Kesan URL, teks, WiFi, kenalan, e-mel, telefon dan banyak lagi',
    accessingCamera: 'Mengakses kamera…',
    cameraDenied: 'Akses kamera dinafikan. Sila benarkan kebenaran kamera dan cuba lagi.',
    noCamera: 'Tiada kamera ditemui pada peranti ini.',
    cameraError: 'Tidak dapat mengakses kamera. Sila cuba lagi.',
    videoError: 'Tidak dapat memulakan main balik video.',
    switchError: 'Tidak dapat menukar kamera.',
    tryAgain: 'Cuba Lagi',
    switchCamera: 'Tukar Kamera',
    stop: 'Berhenti',
    noQrFound: 'Tiada Kod QR Ditemui',
    couldNotRead: 'Tidak dapat membaca imej',
    scannerFailed: 'Pengimbas gagal dimuatkan',
    noQrFoundDesc: 'Tiada kod QR dikesan dalam imej. Cuba imej lain atau gunakan pengimbas kamera.',
    qrScanned: 'Kod QR Diimbas!',
    openLink: 'Buka Pautan',
    copied: 'Disalin!',
    copy: 'Salin',
    share: 'Kongsi',
    scanAgain: 'Imbas Lagi',
    network: 'Rangkaian',
    password: 'Kata Laluan',
    security: 'Keselamatan',
    unknown: 'Tidak diketahui',
    typeText: 'Teks',
    typeUrl: 'URL',
    typeWifi: 'Rangkaian WiFi',
    typeContact: 'Kad Kenalan',
    typeEmail: 'E-mel',
    typePhone: 'Nombor Telefon',
    typeSms: 'SMS',
    typeLocation: 'Lokasi',
    blog: {
      tocTitle: 'Kandungan',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Mengapa guna pengimbas kod QR?',
          paragraphs: [
            'Pengimbas kod QR pada asasnya ialah kamera mudah alih yang menyahkod maklumat yang disimpan dalam kod QR. Anda hanya perlu halakan kamera ke kod QR; tanpa mengira orientasi kod QR, ia akan membaca corak tertentu, mengesan ralat, membetulkan ralat jika perlu, dan memaparkan maklumat di dalamnya.',
          ],
          listTitle: 'Jenis pengimbas kod QR:',
          bullets: [
            'Pengimbas kod QR Berasaskan Web: Anda boleh mengimbas kod QR dengan pengimbas dalam talian yang disokong oleh pelayar anda. Anda boleh mengakses maklumat melalui kamera atau dengan memuat naik imej untuk diimbas. Untuk auto-pengalihan dan ciri lanjutan lain, anda boleh melawat https://photremium.com.',
            'Kamera mudah alih: Sesetengah telefon moden mempunyai pengimbas kod QR terbina dalam aplikasi kamera asal. Ini boleh mendapatkan dan menyahkod maklumat hanya dengan mengimbas kod QR melalui kamera biasa.',
            'Aplikasi: Terdapat beberapa aplikasi yang dibina khusus untuk mengimbas kod QR. Namun, untuk pengalihan lanjutan dan banyak ciri lain, anda boleh memasang aplikasi melalui pautan ini secara percuma: https://photremium.com.',
            'Peranti perkakasan: Sesetengah peranti perkakasan juga dibuat untuk mengimbas kod QR. Peranti ini digunakan secara meluas di pusat beli-belah besar untuk pengebilan barangan.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Mengapa pilih pengimbas kod QR kami?',
          paragraphs: [
            'Anda boleh meneroka pelbagai ciri lanjutan termasuk pengalihan hingga menyalin kandungan yang dinyahkod daripada kod QR. Anda juga boleh meneroka banyak ciri menarik lain dalam pengimbas kod QR kami seperti:',
          ],
          bullets: [
            'Kelajuan Pantas: Pengimbas kod QR kami menjadikan penyahkodan kod QR sangat pantas. Anda hanya perlu mengimbas kod QR, dan alat kami memberi maklumat serta-merta dengan pilihan lanjutan untuk menyalin teks/pautan, membuka jika pautan dikesan, atau menyimpan secara automatik jika kenalan dikesan.',
            'Tiada Pemasangan Diperlukan: Anda tidak perlu memasang aplikasi berasingan untuk mengakses pengimbas kod QR kami. Anda boleh mengakses alat ini melalui pelayar tempatan anda secara percuma.',
            'Akses Merentas Platform: Anda boleh mengaksesnya pada mana-mana peranti. Tidak perlu risau tentang versi OS atau keperluan lain. Ini disokong pada semua versi dan semua peranti.',
            'Semua Format Disokong: Semua format data yang boleh disimpan dalam kod QR termasuk teks biasa, WiFi, URL, kenalan, Gmail, dan Google Maps, dsb. disokong oleh alat kami.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Panduan langkah demi langkah:',
          steps: [
            {
              heading: '1. Pertama sekali, pilih kaedah untuk mengimbas kod QR. Terdapat dua kaedah berikut untuk melakukannya:',
              subSteps: [
                {
                  heading: 'i. Kaedah kamera',
                  paragraphs: [
                    'Anda boleh mengimbas kod QR menggunakan kamera peranti anda walaupun anda menggunakan komputer riba, PC, atau mana-mana peranti yang menyokong kamera biasa. Hanya klik butang “Start Camera” dan permintaan kebenaran akan muncul; benarkan kebenaran untuk laman ini menggunakan kamera anda bagi imbasan QR. Jika anda tersalah tolak atau permintaan kebenaran tidak muncul, anda boleh beri akses kamera secara manual dengan langkah berikut:',
                  ],
                  notes: [
                    '➔ Untuk Chrome (Android / Desktop):',
                    '1. Klik tiga titik',
                    '2. Pergi ke Settings',
                    '3. (Langkau langkah ini untuk Android) Privacy and Security',
                    '4. Klik Site Settings',
                    '5. Kemudian, dalam bahagian permissions, klik Camera',
                    '6. Cari URL laman kami iaitu https://photremium.com/qr-code-scanner',
                    '7. Benarkan kamera daripada menu juntai bawah.',
                    '➔ Untuk Safari (iPhone / iOS):',
                    '1. Ketik ikon AA atau Website Settings pada bar alamat.',
                    '2. Pilih Website Settings.',
                    '3. Ketik Camera dan pilih Allow.',
                    '4. Jika masih disekat: Pergi ke iPhone Settings > Safari > Camera dan tetapkan kepada Ask atau Allow.',
                  ],
                },
                {
                  heading: 'ii. Kaedah galeri',
                  paragraphs: [
                    'Anda boleh memuat naik imej kod QR untuk mengakses maklumatnya. Klik butang “Scan from Gallery”, dan ia akan membuka peneroka fail. Kemudian, pilih imej kod QR. Semua format imej disokong seperti jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz, dan .xbm, dsb.',
                  ],
                },
              ],
            },
            {
              heading: '2. Apabila anda memilih kod QR, semua maklumat akan dipaparkan; membolehkan anda menyalin, berkongsi, atau membuka pautan jika dikesan. Anda juga boleh mengimbas semula jika mahu.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Manfaat pengimbas kod QR:.',
          paragraphs: [
            'Pengimbas kod QR menawarkan beberapa manfaat dalam dunia digital ini. Ia menjadikan pembayaran, pengesahan, dan akses kepada maklumat mudah serta pantas walaupun dalam mod luar talian.',
          ],
          bullets: [
            'Akses segera kepada maklumat: Mengimbas kod QR akan memberikan maklumat dalam beberapa mili saat. Ia menyahkod corak, mengesan ralat, dan membuangnya dengan sangat cepat, memberikan pengalaman yang sangat pantas kepada pengguna.',
            'Komunikasi Lancar: Dalam era kemajuan ini, terdapat keperluan mendesak untuk komunikasi yang pantas dan selamat bagi maklumat kecil seperti butiran bank dan butiran produk, dsb. Pengimbas kod QR menyelesaikan masalah ini kerana pembayaran dibuat dengan mengimbas kod QR. Selain itu, Google mengesahkan telefon mudah alih melalui QR semasa mencipta akaun baharu pada komputer riba.',
            'E-Tiket: Di stesen bas, stesen kereta api, atau lapangan terbang, anda boleh mengesahkan tiket dengan mudah tanpa menunggu giliran dalam barisan lama. Selain itu, pengimbas kod QR dipasang di pelbagai lokasi di lapangan terbang untuk mengelakkan barisan menunggu. Ini juga mengurangkan keperluan pekerja, sekali gus menjimatkan bajet syarikat penerbangan secara automatik.',
            'Pengesahan Produk: Jenama maju dan berkelas tinggi meletakkan kod QR pada produk mereka. Pelanggan boleh mengimbas kod QR tersebut untuk menyemak ketulenan produk sama ada asli atau tidak.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Alat Kabur Wajah — Kaburkan Wajah dalam Imej Dalam Talian | photremium.com',
      uploadDesc: 'Kaburkan wajah dalam imej secara automatik menggunakan pengesanan wajah AI. Pilih keamatan kabur, bentuk atau emoji.',
      uploadKeywords: 'kabur wajah, kaburkan wajah, pengesanan wajah, alat privasi',
      workspaceTitle: 'Alat Kabur Wajah — photremium.com',
      workspaceDesc: 'Kaburkan wajah dalam imej secara automatik. 100% percuma.',
      workspaceKeywords: 'kabur wajah, pengesanan wajah',
    },
    title: 'Kabur Wajah',
    desc: 'Kesan dan kaburkan wajah dalam imej secara automatik untuk privasi.',
    toBlurFaces: 'untuk dikaburkan wajahnya',
    autoDetection: 'Pengesanan Automatik',
    autoDetectionDesc: 'Pengesanan wajah AI mencari semua wajah dengan segera',
    customBlur: 'Kabur Tersuai',
    customBlurDesc: 'Laraskan keamatan, bentuk dan gaya kabur',
    private100: '100% Peribadi',
    private100Desc: 'Semua pemprosesan berlaku secara tempatan dalam pelayar',
    blurTools: 'Alat Kabur',
    faces: 'Wajah',
    faceDetection: 'Pengesanan Wajah',
    detecting: 'Mengesan...',
    autoDetectFaces: 'Kesan Wajah Secara Automatik',
    exitManualMode: 'Keluar dari Mod Manual',
    manualSelect: 'Pilih Manual',
    nFaceRegions: '{n} kawasan wajah ditemui',
    noFacesDetected: 'Tiada wajah dikesan — gunakan mod manual',
    manualHint: 'Klik dan seret untuk melukis segi empat pada kawasan yang ingin dikaburkan.',
    blurType: 'Jenis Kabur',
    blur: 'Kabur',
    emoji: 'Emoji',
    blurIntensity: 'Keamatan Kabur',
    strength: 'Kekuatan',
    blurShape: 'Bentuk Kabur',
    rectangle: 'Segi Empat',
    ellipse: 'Elips',
    circle: 'Bulatan',
    chooseEmoji: 'Pilih Emoji',
    blurRegionsN: 'Kawasan Kabur ({n})',
    faceN: 'Wajah {n}',
    manualRegionN: 'Kawasan Manual {n}',
    manualN: 'Manual {n}',
    clearAllRegions: 'Kosongkan Semua Kawasan',
    processingDots: 'Memproses...',
    downloadBlurred: 'Muat Turun Imej Kabur',
    downloadNImages: 'Muat Turun {n} Imej',
    downloadDialogTitle: 'Tidak Semua Imej Diedit',
    downloadDialogText: 'Anda telah mengedit {edited} daripada {total}.',
    downloadAll: 'Muat Turun Semua',
    removeRegion: 'Buang Kawasan',
    region: 'Kawasan',
    notAllEdited: 'Tidak Semua Imej Diedit',
    editedXofY: 'Anda telah mengedit {edited} daripada {total}.',
    nextImage: 'Imej Seterusnya',
  },

  faqData: {
    imageConverter: [
      { q: 'Format imej apa yang disokong untuk penukaran?', a: 'Kami menyokong JPG, PNG, WEBP, SVG, GIF, BMP, ICO dan TIFF. Anda boleh menukar antara format-format ini seketika dalam pelayar.' },
      { q: 'Adakah kualiti imej terjejas semasa penukaran?', a: 'Untuk format tanpa kehilangan seperti PNG, kualiti dikekalkan sepenuhnya. Untuk format dengan kehilangan seperti JPG dan WEBP, kami menggunakan tetapan pengekodan yang dioptimumkan.' },
      { q: 'Adakah terdapat had saiz atau kuantiti fail?', a: 'Tiada had yang ketat. Anda boleh memuat naik beberapa imej sekaligus dan menukarnya secara pukal.' },
      { q: 'Adakah data saya selamat? Adakah imej dimuat naik ke pelayan?', a: 'Semestinya. Semua pemprosesan berlaku dalam pelayar anda. Imej anda tidak pernah meninggalkan peranti anda.' },
      { q: 'Bolehkah saya menukar imej PNG telus ke JPG?', a: 'Ya. Oleh kerana JPG tidak menyokong ketelusan, kawasan telus akan diisi dengan latar belakang putih secara lalai.' },
    ],
    imageCompressor: [
      { q: 'Adakah pemampatan imej akan mengurangkan kualiti?', a: 'Tidak, pemampatan imej tidak menjejaskan kualiti selagi anda tidak melebihi had yang disyorkan. Penunjuk membantu anda menilai kualiti: i. Pemampatan 1% hingga 40%: penunjuk hijau dengan mesej “Kualiti Baik”. ii. Pemampatan 41% hingga 60%: penunjuk kuning dengan mesej “Kualiti Normal”. Julat ini biasanya paling disyorkan. iii. Pemampatan 61% hingga 100%: sistem memaparkan amaran merah “Kualiti Rendah”, dan penurunan kualiti mungkin ketara.' },
      { q: 'Format imej apa yang disokong untuk pemampatan?', a: 'Alat pemampat imej kami menyokong semua format berikut:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Bolehkah saya memampatkan banyak imej serentak?', a: 'Ya, sudah tentu. Anda boleh memampatkan banyak imej serentak (malah 100+) jika peranti anda menyokongnya. Oleh sebab proses ini menggunakan sumber sistem, laptop, PC atau telefon berprestasi tinggi akan memberi hasil lebih baik. Jika peranti anda rendah spesifikasi, anda masih boleh memampatkan secara berkelompok kerana alat ini kekal percuma walaupun digunakan dalam banyak batch.' },
      { q: 'Adakah anda menyimpan atau memuat naik imej kami ke pelayan anda?', a: 'Tidak, kami tidak memuat naik atau menyimpan imej anda pada pelayan kami. Semua imej dimampatkan secara setempat dalam pelayar anda. Imej anda tidak pernah meninggalkan peranti, jadi anda boleh memampatkan imej peribadi atau sulit dengan tenang.' },
      { q: 'Adakah alat pemampat imej ini percuma?', a: 'Ya, alat pemampat imej kami adalah percuma sepenuhnya untuk selama-lamanya. Kami tidak akan meminta sebarang bayaran. Tiada caj tersembunyi. Semua ciri, termasuk pemampatan berbilang imej, adalah percuma.' },
    ],
    cropImage: [
      { q: 'Adakah memotong imej akan mengurangkan kualitinya?', a: 'Tidak, memotong imej tidak akan menjejaskan kualiti visual imej langsung. Pemotongan hanya membuang bahagian yang tidak diperlukan. Ia tidak mengubah piksel pada bahagian imej yang kekal selepas dipotong. Jadi anda boleh memotong imej dengan kualiti asal tanpa sebarang kerosakan piksel.' },
      { q: 'Apakah format imej yang disokong oleh pemotong imej?', a: 'Anda boleh memilih imej dalam apa-apa format kerana alat pemotong imej kami menyokong hampir semua format imej. Ia disenaraikan di bawah:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Adakah imej saya dimuat naik ke pelayan anda?', a: 'Tidak, semua pemprosesan dilakukan dalam pelayar setempat anda. Imej anda tidak akan dimuat naik ke pelayan kami kerana imej tidak pernah meninggalkan peranti anda. Jadi anda boleh memotong imej peribadi dengan pemotong imej kami tanpa sebarang risiko.' },
      { q: 'Bolehkah saya memotong beberapa imej serentak?', a: 'Ya, anda boleh memotong beberapa imej (malah 100+) serentak jika sistem anda menyokongnya. Oleh sebab pemotongan menggunakan sumber sistem, jika anda mempunyai laptop, PC atau telefon berprestasi tinggi, anda boleh memotong banyak imej sekaligus. Jika peranti anda berprestasi rendah, anda boleh memotong imej secara kelompok kerana alat ini percuma digunakan walaupun anda memotong banyak imej.' },
      { q: 'Adakah alat pemotong imej ini percuma untuk digunakan?', a: 'Ya, alat pemotong imej ini adalah percuma sepenuhnya untuk selama-lamanya. Anda boleh mengaksesnya di mana-mana, pada bila-bila masa dan menggunakan mana-mana peranti. Anda bukan sahaja akan mendapat reka bentuk responsif untuk semua peranti, malah anda juga tidak akan diminta membayar sebarang ciri premium. Semua ciri adalah percuma sepenuhnya tanpa caj tersembunyi.' },
    ],
    resizeImage: [
      { q: 'Bolehkah saya mengubah saiz berbilang imej serentak?', a: 'Sudah tentu. Alat pengubah saiz imej kami menyokong pengubahan saiz berbilang imej pada masa yang sama. Anda boleh memuat naik sebanyak imej yang disokong peranti anda dan enjin AI kami akan memproses semuanya serentak. Namun, jika peranti anda berprestasi rendah, lebih baik proses dalam batch untuk elak lag. Semua pemprosesan berlaku secara setempat tanpa muat naik pelayan, jadi privasi imej anda kekal terpelihara.' },
      { q: 'Adakah alat pengubah saiz imej ini percuma?', a: 'Ya, alat ini percuma sepenuhnya untuk selama-lamanya. Tiada langganan berbayar diperlukan untuk ciri premium. Tiada caj tersembunyi semasa memuat turun imej yang telah diubah saiz.' },
      { q: 'Adakah pengubahan saiz imej menurunkan kualiti?', a: '✅Decrease Size (downscale): Mengurangkan saiz imej tidak menurunkan kualiti visual. Malah, imej yang dikecilkan boleh kelihatan lebih tajam berbanding imej asal. Jadi, mengecilkan imej ke saiz lebih kecil biasanya tidak menyebabkan kehilangan kualiti.\n❌Increase Size (upscale): Membesarkan imej melebihi saiz asal boleh menjejaskan kualiti visual. Kesan bergantung pada sejauh mana imej dibesarkan. Jika dibesarkan secara berlebihan, penurunan kualiti akan lebih ketara.' },
      { q: 'Adakah alat pengubah saiz imej ini selamat?', a: 'Ya, alat kami selamat digunakan, terutamanya untuk imej peribadi atau sensitif. Semua imej diproses setempat pada peranti anda dan tiada data meninggalkan peranti. Anda boleh mengubah saiz imej peribadi tanpa sebarang risiko privasi.' },
      { q: 'Format imej apa yang disokong?', a: 'Pengubah saiz imej kami menyokong semua format imej. Anda boleh memilih imej dalam mana-mana format berikut:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Bagaimana pembuangan latar belakang berfungsi?', a: 'Kami menggunakan model AI lanjutan yang berjalan terus dalam pelayar untuk mengesan subjek dan memisahkannya dari latar belakang.' },
      { q: 'Adakah ia berfungsi untuk latar belakang yang kompleks?', a: 'Ya. Model AI mengendalikan pelbagai adegan. Hasil terbaik apabila terdapat kontras yang jelas antara subjek dan latar belakang.' },
      { q: 'Bolehkah saya membuang latar belakang dari beberapa imej serentak?', a: 'Ya. Muat naik beberapa imej dan alat akan memprosesnya secara berurutan.' },
      { q: 'Apakah format output?', a: 'Output sentiasa fail PNG dengan latar belakang telus.' },
      { q: 'Adakah imej saya dihantar ke pelayan?', a: 'Tidak. Model AI berjalan sepenuhnya dalam pelayar menggunakan WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Adakah alat tera air Photremium percuma?', a: 'Ya, alat di photremium.com/watermark-image boleh digunakan secara percuma tanpa akaun atau langganan. Anda boleh tera air imej tunggal atau kumpulan tanpa sekatan atau paywall.' },
      { q: '2. Berapakah bilangan imej yang boleh diproses serentak?', a: 'Alat ini menyokong pemprosesan berkumpulan. Seret folder gambar atau pilih banyak fail pada satu masa — had praktikal ditentukan oleh memori peranti anda.' },
      { q: '3. Format imej input dan output yang disokong?', a: 'Menyokong format yang boleh dibaca oleh File API: JPEG, JPG, PNG, WEBP, GIF (statik), BMP dan SVG. Output mengekalkan format asal.' },
      { q: '4. Adakah tera air kelihatan serupa pada resolusi berbeza?', a: 'Ya. Enjin penempatan berkadar mengira kedudukan relatif dan skala supaya tera air mengekalkan rupa yang sama merentasi semua imej dalam kumpulan.' },
      { q: '5. Bolehkah saya gunakan logo sendiri sebagai tera air?', a: 'Boleh. Gunakan "Add Image" untuk memuat naik PNG dengan latar telus; anda boleh mengubah saiz, putar dan laraskan kelegapan.' },
      { q: '6. Bagaimana menjadikan tera air separa telus?', a: 'Pilih lapisan tera air pada kanvas dan laraskan slider kelegapan — 30–50% biasa memberikan kesan profesional tanpa mengganggu imej.' },
      { q: '7. Bolehkah saya menambah berbilang lapisan tera air dalam satu imej?', a: 'Ya. Sistem lapisan membenarkan berbilang lapisan dengan konfigurasi berasingan untuk setiap satu.' },
      { q: '8. Apakah fungsi tiling dan bila digunakan?', a: 'Tiling mengulang tera air dalam grid di seluruh imej dan sesuai untuk memastikan imej tidak boleh digunakan tanpa kebenaran.' },
      { q: '9. Adakah alat ini sesuai untuk mudah alih?', a: 'Ya — susun atur responsif menukar kepada paparan bertindih pada skrin sempit dan semua kawalan menyokong sentuhan.' },
      { q: '10. Adakah imej saya peribadi dan adakah ia dihantar ke pelayan?', a: 'Imej anda tidak meninggalkan peranti. Semua pemprosesan berlaku secara tempatan dalam pelayar menggunakan Canvas API dan tiada muat naik imej dilakukan.' },
    ],
    qrCodeGenerator: [
      { q: 'Adakah kod QR ini akan luput?', a: 'Tidak, kod-kod QR ini tidak akan luput dan menjamin sokongan seumur hidup. Kerana ia menyimpan arahan berkod dalam bentuk bit di dalam kotak segi empat, maklumat yang disimpan di dalamnya tidak boleh diubah atau dibuang. Anda boleh mengakses maklumat dalam kod hanya dengan mengimbas ia dengan mana-mana kamera walaupun selepas bertahun-tahun.' },
      { q: 'Mengapa kod QR saya tidak dapat diimbas?', a: 'Kod QR anda mungkin gagal diimbas kerana sebab-sebab berikut: i. Kontras Rendah: Jika anda memilih warna latar belakang dan latar depan yang serupa, ia mempengaruhi keterlihatan kod QR dan menyebabkan kegagalan pengimbasan. Tetapi alat kami membimbing anda semasa penyesuaian tentang kontras rendah atau sebarang isu berkaitan pengimbasan lain. ii. Data Besar: Jika anda menjana kod QR untuk teks atau data yang sangat besar, ia menjadi sangat kompleks dan menyebabkan masalah semasa mengimba. Pengesah panjang teks membimbing anda tentang panjang teks yang optimum semasa penjanaan kod QR. iii. Cetakan Kabur: Pastikan anda memuat turun kod QR anda dalam format resolusi tinggi seperti PNG atau SVG yang telah disokong oleh alat kami.' },
      { q: 'Bolehkah saya menambah logo dalam kod QR?', a: 'Sudah tentu, anda boleh menambah logo tersuai atau memilih satu daripada perpustakaan logo dalam kod QR anda. Logo pilihan anda akan diselaraskan secara automatik di tengah kod QR.' },
      { q: 'Bagaimanakah saya boleh mengimba kod QR?', a: 'Anda boleh mengimba kod QR menggunakan kamera mudah alih anda. Tetapi untuk pengalihan automatik ke pautan dan banyak lagi ciri-ciri canggih, anda boleh melawati pengimba kod QR kami menggunakan pautan https://photremium.com/qr-code-scanner secara percuma.' },
      { q: 'Berapa banyak kod QR yang boleh saya janakan secara percuma?', a: 'TIDAK TERBATAS! anda boleh menjana pelbagai kod QR secara percuma. Semua ciri, penyesuaian dan templat adalah percuma selamanya untuk semua. Tidak perlu melanggan untuk menikmati ciri premium.' },
      { q: 'Adakah saya perlu log masuk/daftar untuk menjana kod QR?', a: 'Tidak, hanya masukkan teks anda, janakan kod QR dan muat turun selepas penyesuaian. Tidak perlu log masuk atau daftar kerana semua ciri boleh diakses sepenuhnya tanpa kos.' },
    ],
    qrCodeScanner: [
      { q: 'Bolehkah saya mengimbas kod QR daripada imej tersimpan dan tangkapan skrin?', a: '**Ya**, anda boleh mengimbas kod QR daripada imej tersimpan atau tangkapan skrin. Pengimbas kod QR kami https://photremium.com/qr-code-scanner membolehkan anda mengimbas kod QR daripada galeri. Anda hanya perlu memilih imej dan anda akan mendapat semua maklumat yang ditebus daripada kod QR itu.' },
      { q: 'Adakah saya perlu memasang Aplikasi untuk pengimbas kod QR?', a: '**Tidak**, pengimbas kod QR berasaskan web kami membolehkan anda mengimbas kod QR tanpa perlu memasang sebarang aplikasi. Anda boleh mengakses pengimbas kod QR lanjutan kami pada mana-mana peranti secara percuma.' },
      { q: 'Mengapa pengimbas tidak mengenali kod QR?', a: 'Kod QR anda tidak diimbas disebabkan salah satu sebab berikut: i. Cahaya tidak mencukupi: Mengimbas kod QR dalam cahaya malap boleh menyebabkan masalah imbasan. Hidupkan lampu suluh dan tingkatkan kecerahan jika anda mengimbas dari mana-mana skrin. ii. Jarak: Mengimbas kod QR dari jarak yang tidak sesuai juga akan menyebabkan isu. Jarak optimum untuk mengimbas kod QR ialah sekitar 10 inci (25cm). iii. Lensa kamera kotor: Kod QR juga boleh gagal diimbas kerana lensa kotor. Bersihkan lensa sebelum mengimbasnya. “Anda nampak grid kotak dalam pengimbas? Hanya muatkan kod QR ke dalamnya untuk mengimbasnya dengan berjaya.”' },
      { q: 'Adakah alat ini mengimbas kod QR songsang atau berwarna?', a: '**Ya**, anda boleh mengimbas QR dalam sebarang warna atau orientasi. Namun, jika kontras warna latar belakang dan latar hadapan rendah, ia mungkin menyebabkan kesukaran semasa mengimbas.' },
      { q: 'Adakah alat ini percuma untuk digunakan?', a: '**Ya**, alat ini sepenuhnya percuma untuk digunakan. Anda boleh mengimbas kod QR tanpa had secara percuma selama-lamanya.' },
    ],
    faceBlur: [
      { q: 'Bagaimana pengesanan wajah berfungsi?', a: 'Model pengesanan wajah berkuasa AI berjalan terus dalam pelayar anda. Ia mengenal pasti wajah dalam imej.' },
      { q: 'Bolehkah saya memilih wajah yang ingin dikaburkan?', a: 'Ya. Selepas pengesanan, setiap kawasan wajah diserlahkan dan anda boleh memilih wajah yang ingin dikaburkan.' },
      { q: 'Gaya kabur apa yang tersedia?', a: 'Anda boleh memilih kabur Gaussian, pikselasi atau hamparan warna pepejal, dan melaraskan keamatan.' },
      { q: 'Bolehkah saya mengaburkan wajah dalam beberapa imej serentak?', a: 'Ya. Muat naik beberapa imej, konfigurasi kawasan kabur, kemudian muat turun semua imej yang diproses.' },
      { q: 'Adakah foto saya dihantar ke pelayan jauh?', a: 'Tidak. Model AI berjalan dalam pelayar anda menggunakan WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Ciri pengeditan apa yang tersedia?', a: 'Laraskan kecerahan, kontras, ketepuan, guna penapis, tambah teks, hamparan, bingkai dan pelekat — semua dalam pelayar.' },
      { q: 'Bolehkah saya membatalkan dan membuat semula perubahan?', a: 'Ya. Editor menyokong sejarah buat asal/buat semula yang lengkap.' },
      { q: 'Format fail apa yang boleh diedit dan dieksport?', a: 'Anda boleh mengedit JPG, PNG, WEBP dan format biasa lain.' },
      { q: 'Adakah editor berfungsi pada telefon?', a: 'Ya. Editor adalah responsif sepenuhnya dan mesra sentuh.' },
      { q: 'Adakah imej saya disimpan di pelayan?', a: 'Tidak. Semua pengeditan dilakukan secara tempatan.' },
    ],
  },
};

export default ms;
